<template>
  <!-- DSR详情 -->
  <div class="page-container">
    <el-form :model="DsrDetailForm" ref="DsrDetailFormRef" class="form-panel" label-position="left">
  <!--     <el-row class="panel-top">
          <el-scrollbar ref="statusScrollPane" class="tags-view-wrapper">
            <div v-for="(item,index) in axisStatusList" :key="index" >
              <div class="node-content">
                <img :src="item.completeStatus == 0?
                                     icon1:item.completeStatus == 1?
                                     icon2:item.completeStatus == 2?
                                     icon3:item.completeStatus == 3?
                                     icon4:item.completeStatus == 4?
                                     icon5:item.completeStatus == 5?
                                     icon6:item.completeStatus == 6?
                                     icon7:item.completeStatus == 7?
                                     icon8:icon9"
                     class="node-content-img"/>
                <div v-if="index!==axisStatusList.length-1"
                     :class="[4, 5, 6, 7].indexOf(item.completeStatus) === -1?'solid-style':'solid-style'"></div>
                <div class="node-content-name">{{ item.statusName }}</div>
                <span class="node-content-date">{{ item.statusCreateTime }}</span>
              </div>
            </div>
          </el-scrollbar>
      </el-row> -->

      <el-row class="panel-top">
        <el-form class="form-panel" label-position="top" id="boxDiv1">

          <el-row type="flex" justify="start" align="top">
            <el-col :span="10" class="transceiver-module">
              <el-row>
                <eb-party-info
                  @getEbPartyInfo="getEbPartyInfo"
                  @ebPartyValidate="ebPartyValidate"
                  :ebParty="ebParty"
                  :ebOrder="ebOrder"
                  editable="true"
                  ref="ebPartyRef"/>
              </el-row>

              <el-row class="panel-top dock-planner-box" style="height:unset">
                <el-col>
                  <div class="tab-external">
                        <div class="tab">
                          <span class="tab-item cursor" :class="{'tab-active': boxVisible}" @click="boxInfoFn">Container</span>
                          <span class="tab-item cursor" :class="{'tab-active': !boxVisible}" @click="boxDetailFn">Container detail</span>
                       </div>
                    </div>
                  <el-row class="content-panel" id="boxDiv">
                    <el-col v-show="boxVisible">
                      <el-row :gutter="1" style="margin:0 0 10px -2px">
                      <el-col :span="6" class="planner-box-btns">
                         <el-col :span="6" class="add-button">
                          <el-button type="primary" size="mini" icon="el-icon-circle-plus-outline"
                                     :disabled="ebOrder.orderStatus!=='NEW'"
                                     @click="addNewRow()">Add</el-button>
                         </el-col>
<!--                        <el-col :span="18" class="synchronous-btn">-->
<!--                          <el-button type="primary" size="mini"-->
<!--                                     @click="synchronizeToDetail(false)"-->
<!--                          >Synchronize to pre-allocation box details</el-button>-->
<!--                        </el-col>-->
                      </el-col>
                       <el-col :span="12" style="padding-left:20px">
                          <span
                            style="padding-left:20px;display: block;width: 100%;word-break: break-word;color: red;">{{
                              ebOrder.ctnNum
                            }}</span>
                      </el-col>
                        <el-col :span="3" >
                          <el-button type="danger" size="mini" class="delete-btn" icon="el-icon-delete"
                                     :disabled="ebOrder.orderStatus!=='NEW'"
                                     @click="batchDeleteEbCtnRequest"></el-button>
                        </el-col>
                      </el-row>
                     <el-row class="dock-planner-box-container">
                     <el-row class="panel-top dock-planner-box-table">
                        <hot-table
                          ref="ebCtnRequestRef"
                          :data-source="ebCtnRequests"
                          :settings="ebCtnRequestSettings"
                          @cellDblclick="ebCtnRequestCellClick"
                          @rowDblclick="ebCtnRequestRowClick"
                          :rules="ebCtnRequestRules"
                        >
                          <hot-column :has-tip="true" data="ctnQuantity" title="<label style='color:red'>*</label>QTY">
                            <el-input-number-editor
                              :controls="false"
                              :precision="0"
                              :min="0"
                              case="upper"
                              hot-editor
                              disabled="true"
                              name="ctnQuantity"/>
                          </hot-column>
                          <hot-column :has-tip="true" data="ctnSizeType"
                                      title="<label style='color:red'>*</label>CTN Size type">
                            <el-associate-editor
                              hot-editor
                              style="width: 100%;"
                              :columns="associate_columns_ctnSizeType"
                              :query-method="associate_queryMethod_ctnSizeType"
                              class="input_length"
                              clearable
                              :query-length="0"
                              :default-first-option="true"
                              label-prop="containerType"
                              value-prop="containerType"
                              placeholder=""
                              size="small"
                              disabled="true"
                              name="ctnSizeType"
                            />
                          </hot-column>
                          <hot-column :has-tip="true" data="isSoc" title="SOC" className="htCenter"
                                      type="checkbox" :checked-template="1" checked-display="是" :unchecked-template="0"
                                      unchecked-display="否" width="50"></hot-column>
                          <hot-column :has-tip="true" data="isNor" title="NOR" className="htCenter"
                                      type="checkbox" :checked-template="1" checked-display="是" :unchecked-template="0"
                                      unchecked-display="否" width="50"></hot-column>
                          <hot-column :has-tip="true" data="ctnCompanyName" title="CTN Company" width="100">
                            <el-associate-editor
                              hot-editor
                              style="width: 100%;"
                              :columns="associate_columns_ctnCompany"
                              :query-method="associate_queryMethod_ctnCompany"
                              class="input_length"
                              clearable
                              :query-length="0"
                              :default-first-option="true"
                              label-prop="custNameCn"
                              value-prop="custNameCn"
                              placeholder=""
                              size="small"
                              disabled="true"
                              name="ctnCompanyName"
                              @change="onChangeCtnCompany"
                            />
                          </hot-column>
                        </hot-table>
                      </el-row>
                       </el-row>
                    </el-col>
                    <el-col v-show="!boxVisible">
                      <hot-table
                        ref="ebCtnRequestDetailRef"
                        :data-source="ebCtnRequestDetails"
                        :settings="ebCtnRequestDetailSettings"
                        @cellDblclick="ebCtnRequestDetailCellClick"
                        @rowDblclick="ebCtnRequestDetailRowClick"
                        :rules="ebCtnRequestDetailRules"
                      >
<!--                         <hot-column :has-tip="true" data="noOfPackage" title="NUM" width="50">
                          <el-input-number-editor
                            :controls="false"
                            :precision="0"
                            :min="0"
                            hot-editor
                            name="noOfPackage"
                            case="upper"/>
                        </hot-column> -->
                        <hot-column :has-tip="true" data="ctnSizeType" title="Container Size&type" width="50"></hot-column>
                        <hot-column type="numeric"
                                    :numericFormat="{
                                                pattern: '0,0.000',
                                                culture: 'zh-CN'
                                                }"
                                    :has-tip="true" data="noOfPackage" title="Qualtity" width="50">
                          <el-input-number-editor
                            :controls="false"
                            :precision="3"
                            :min="0"
                            hot-editor
                            case="upper"
                            disabled="true"
                            name="grossWeight"/>
                        </hot-column>
                        <hot-column type="numeric"
                                    :numericFormat="{
                                                pattern: '0,0.000',
                                                culture: 'zh-CN'
                                                }"
                                    :has-tip="true" data="grossWeight" title="G.W.(kgs)" width="50">
                          <el-input-number-editor
                            :controls="false"
                            :precision="3"
                            :min="0"
                            hot-editor
                            case="upper"
                            disabled="true"
                            name="grossWeight"/>
                        </hot-column>
                        <hot-column type="numeric"
                                    :numericFormat="{
                                                pattern: '0,0.000',
                                                culture: 'zh-CN'
                                                }"
                                    :has-tip="true" data="netWeight" title="N.W.(kgs)" width="50">
                          <el-input-number-editor
                            :controls="false"
                            :precision="3"
                            :min="0"
                            hot-editor
                            case="upper"
                            disabled="true"
                            name="netWeight"/>
                        </hot-column>
<!--                         <hot-column type="numeric"
                                    :numericFormat="{
                                                pattern: '0,0.000',
                                                culture: 'zh-CN'
                                                }"
                                    :has-tip="true" data="PWeight" title="PKGS" width="50">
                          <el-input-number-editor
                            :controls="false"
                            :precision="3"
                            :min="0"
                            hot-editor
                            case="upper"
                            name="grossWeight"/>
                        </hot-column>
                        <hot-column type="numeric"
                                    :numericFormat="{
                                                pattern: '0,0.000',
                                                culture: 'zh-CN'
                                                }"
                                    :has-tip="true" data="grossWeight" title="G.W.(kgs)" width="50">
                          <el-input-number-editor
                            :controls="false"
                            :precision="3"
                            :min="0"
                            hot-editor
                            case="upper"
                            name="grossWeight"/>
                        </hot-column>
                        <hot-column type="numeric"
                                    :numericFormat="{
                                                pattern: '0,0.000',
                                                culture: 'zh-CN'
                                                }"
                                    :has-tip="true" data="netWeight" title="N.W.(kgs)" width="50">
                          <el-input-number-editor
                            :controls="false"
                            :precision="3"
                            :min="0"
                            hot-editor
                            case="upper"
                            name="netWeight"/>
                        </hot-column> -->
<!--                         <hot-column type="numeric"
                                    :numericFormat="{
                                                pattern: '0,0.000',
                                                culture: 'zh-CN'
                                                }"
                                    :has-tip="true" data="cube" title="Measurement(cbm)" width="50">
                          <el-input-number-editor
                            :controls="false"
                            :precision="3"
                            :min="0"
                            hot-editor
                            case="upper"
                            name="cube"/>
                        </hot-column> -->
                        <hot-column type="numeric"
                                    :numericFormat="{
                                                pattern: '0,0.000',
                                                culture: 'zh-CN'
                                                }"
                                    :has-tip="true" data="cube" title="Cube" width="50">
                          <el-input-number-editor
                            :controls="false"
                            :precision="3"
                            :min="0"
                            hot-editor
                            case="upper"
                            disabled="true"
                            name="netWeight"/>
                        </hot-column>
                        <hot-column :has-tip="true" data="cargoDescription" title="Description of Cargo" width="100">
                          <el-input-editor
                            hot-editor
                            case="upper"
                            data="cargoDescription"
                            disabled="true"
                          />
                        </hot-column>
                        <hot-column :has-tip="true" data="marks" title="MARKS" width="100">
                          <el-input-editor
                            hot-editor
                            case="upper"
                            data="marks"
                            disabled="true"
                          />
                        </hot-column>
                      <hot-column :has-tip="true" data="isSoc" title="SOC" className="htCenter"
                                    type="checkbox" :checked-template="1" checked-display="是" :unchecked-template="0"
                                    unchecked-display="否" width="50"></hot-column>
                        <hot-column :has-tip="true" data="isNor" title="NORC" className="htCenter"
                                    type="checkbox" :checked-template="1" checked-display="是" :unchecked-template="0"
                                    unchecked-display="否" width="50"></hot-column>
                      </hot-table>
                    </el-col>
                  </el-row>
                </el-col>
              </el-row>
            </el-col>

            <el-col :span="14" class="left-margin">
              <el-form :disabled="ebOrder.orderStatus === 'UPDSUB' || ebOrder.orderStatus === 'SUB'"
                       ref="bookingFormRef" :rules="bookingFormRules" :model="ebOrder" class="form-panel"
                       label-position="top">
                <!-- 基本信息-start -->
                <div>
                  <el-row class="title-panel-external">
                    <div class="title-panel">
                      <el-col>
                      <span class="title-text">Basic</span>
                    </el-col>
<!--                    <el-col>-->
<!--                      <span class="title-text" style="float: right;color: red">Carrier ：MSK</span>-->
<!--                    </el-col>-->
                    </div>
                </el-row>
                  <el-row class="content-panel">
                    <el-col>
                      <el-row :gutter="10">
                        <el-col :span="8">
                          <el-form-item label="Booking No：">
                            <el-input size="mini" case="upper" v-model="ebOrder.orderNo" disabled></el-input>
                          </el-form-item>
                        </el-col>
                        <el-col :span="8">
                          <el-form-item label="Customer No：" prop="custBizNo">
                            <el-input size="mini" case="upper" v-model="ebOrder.custBizNo" disabled></el-input>
                          </el-form-item>
                        </el-col>
                        <el-col :span="8">
                          <el-form-item label="MBL No：">
                            <el-input size="mini" case="upper" v-model.trim="ebOrder.mblNo" disabled></el-input>
                          </el-form-item>
                        </el-col>
                      </el-row>
                    </el-col>
                    <el-col>
                      <el-row :gutter="10">
                        <el-col :span="8">
                          <el-form-item label="Carrier：" prop="carrierName">
                            <el-associate style="width: 100%;"
                                          :columns="associate_columns_carrier"
                                          :query-method="associate_queryMethod_carrier"
                                          class="input_length"
                                          clearable
                                          disabled
                                          case="upper"
                                          :query-length="0"
                                          :default-first-option="true"
                                          label-prop="custAlias"
                                          value-prop="custAlias"
                                          placeholder=""
                                          v-model="ebOrder.carrierShortName"
                                          size="mini"
                                          @change="onChangeCarrier"
                            />
                          </el-form-item>
                        </el-col>
                       <el-col :span="8">
                          <el-form-item label="Payment：" prop="mblPaymentType">
                            <el-select class="length_input" size="mini" v-model="ebOrder.hblPaymentType"
                                       placeholder="Please select" disabled>
                              <el-option
                                v-for="item in mblPaymentTypeList"
                                :key="item.key"
                                :label="item.value"
                                :value="item.key"
                              >
                              </el-option>
                            </el-select>
                          </el-form-item>
                        </el-col>
                        <el-col :span="8">
                          <el-form-item label="Payment At：" prop="carrierName">
                            <el-associate style="width: 100%;"
                                          :columns="associate_columns_carrier"
                                          :query-method="associate_queryMethod_carrier"
                                          class="input_length"
                                          clearable
                                          disabled
                                          case="upper"
                                          :query-length="0"
                                          :default-first-option="true"
                                          label-prop="custAlias"
                                          value-prop="custAlias"
                                          placeholder=""
                                          v-model="ebOrder.mblPaymentPlace"
                                          size="mini"
                                          @change="onChangeCarrier"
                            />
                          </el-form-item>
                        </el-col>


                        <!-- <el-col :span="8">
                            <el-form-item label="付款人:">
                            <el-input size="mini" v-model="ebOrder.mblPaymentContact"></el-input>
                            </el-form-item>
                        </el-col> -->

                      <!-- <el-col :span="8">
                          <el-row :gutter="5">
                            <el-col :span="12">
                              <el-form-item label="运输条款:" prop="mblTransportTermFrom">
                                <el-select class="length_input" size="mini" v-model="ebOrder.mblTransportTermFrom"
                                           :placeholder="$t('table.pleaseSelect')">
                                  <el-option
                                    v-for="item in mblTransportTermList"
                                    :key="item.key"
                                    :label="item.value"
                                    :value="item.key"
                                  >
                                  </el-option>
                                </el-select>
                              </el-form-item>
                            </el-col>
                            <el-col :span="12">
                              <el-form-item>
                                <label slot="label" class="label_no"></label>
                                <el-select class="length_input" size="mini" v-model="ebOrder.mblTransportTermTo"
                                           :placeholder="$t('table.pleaseSelect')">
                                  <el-option
                                    v-for="item in mblTransportTermList"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value"
                                  >
                                  </el-option>
                                </el-select>
                              </el-form-item>
                            </el-col>
                          </el-row>
                        </el-col>-->
                      </el-row>
                    </el-col>
                    <el-col>
                      <el-row :gutter="10">
                   <el-col :span="8">
                      <el-row :gutter="5">
                        <el-col :span="12">
                          <el-form-item
                              label="Transport Term："
                              prop="mblTransportTermFrom"
                              class="redItem"
                          >
                            <el-select
                                class="length_input"
                                size="mini"
                                v-model="ebOrder.mblTransportTermFrom"
                                :placeholder="$t('table.pleaseSelect')"
                                ref="mblTransportTermFrom"
                                disabled
                            >
                              <el-option
                                  v-for="item in mblTransportTermList"
                                  :key="item.key"
                                  :label="item.value"
                                  :value="item.key"
                              >
                              </el-option>
                            </el-select>
                          </el-form-item>
                        </el-col>
                        <el-col :span="12">
                          <el-form-item>
                            <label slot="label" class="label_no"></label>
                            <el-select
                                class="length_input"
                                size="mini"
                                v-model="ebOrder.mblTransportTermTo"
                                :placeholder="$t('table.pleaseSelect')"
                                disabled
                            >
                              <el-option
                                  v-for="item in mblTransportTermList"
                                  :key="item.value"
                                  :label="item.label"
                                  :value="item.value"
                              >
                              </el-option>
                            </el-select>
                          </el-form-item>
                        </el-col>
                      </el-row>
                    </el-col>

                        <el-col :span="8">
                          <el-form-item label="S/C NO：" prop="agreementNo">
                            <el-input size="mini" case="upper" v-model="ebOrder.agreementNo" disabled></el-input>
                          </el-form-item>
                        </el-col>
                        <el-col :span="8">
                          <el-form-item label="N/A：">
                            <el-input size="mini" case="upper" v-model="ebOrder.nameAccount" disabled></el-input>
                          </el-form-item>
                        </el-col>
                      </el-row>
                    </el-col>

                    <el-col>
                      <el-row :gutter="10">
                        <el-col :span="8">
                          <el-form-item label="BL Type：" prop="issueMode">
                            <el-select class="length_input" size="mini" @change="changeIssueMode"
                                       v-model="ebOrder.issueMode"
                                       placeholder="Please select" disabled>
                              <el-option
                                v-for="item in issueModeList"
                                :key="item.key"
                                :label="item.value"
                                :value="item.key"
                              >
                              </el-option>
                            </el-select>
                          </el-form-item>
                        </el-col>
                        <el-col :span="8">
                          <el-form-item label="Issue Place：">
                            <el-associate style="width: 100%;"
                                          :columns="associate_columns_po"
                                          :query-method="associate_queryMethod_po"
                                          class="input_length"
                                          clearable
                                          disabled
                                          :query-length="0"
                                          :default-first-option="true"
                                          label-prop="portNameEn"
                                          value-prop="mdPortId"
                                          placeholder=""
                                          v-model="ebOrder.placeOfIssueName"
                                          size="mini"
                                          @change="changePlaceOfIssueName"
                            />
                          </el-form-item>
                        </el-col>
                        <el-col :span="8">
                          <el-row>
                            <el-col :span="12">
                              <el-form-item label="MBLQuality/CopyQuality：" prop="noOfOriginal">
                                <el-select class="length_input" size="mini" v-model="ebOrder.noOfOriginal"
                                           placeholder="Please select" disabled>
                                  <el-option
                                    v-for="item in noOfOriginalList"
                                    :key="item.key"
                                    :label="item.value"
                                    :value="item.key"
                                  >
                                  </el-option>
                                </el-select>
                              </el-form-item>
                            </el-col>
                            <el-col :span="12">
                              <el-form-item>
                                <label slot="label" class="label_no"></label>
                                <el-select class="length_input" size="mini" v-model="ebOrder.noOfCopy"
                                           placeholder="Please select" disabled>
                                  <el-option
                                    v-for="item in noOfOriginalList"
                                    :key="item.key"
                                    :label="item.value"
                                    :value="item.key"
                                  >
                                  </el-option>
                                </el-select>
                              </el-form-item>
                            </el-col>
                          </el-row>
                        </el-col>
                      </el-row>
                    </el-col>
                                    <el-col>
                  <el-row :gutter="10">
                    <el-col :span="8">
                      <el-row>
                        <el-col :span="8">
                          <el-form-item label="Inside:" prop="freeStorage">
                            <el-input
                                size="mini"
                                case="upper"
                                onkeyup="value=value.replace(/[^\d]/g,'')"
                                @change="sumFreeDaysChange"
                                v-model="ebOrder.freeStorage"
                                :min="0"
                                disabled
                            ></el-input>
                          </el-form-item>
                        </el-col>
                        <el-col :span="8">
                          <el-form-item label="Outside:" prop="freeOfDetention">
                            <!-- <label slot="label" class="label_no"></label> -->
                            <el-input
                                size="mini"
                                case="upper"
                                onkeyup="value=value.replace(/[^\d]/g,'')"
                                @change="sumFreeDaysChange"
                                v-model="ebOrder.freeOfDetention"
                                :min="0"
                                disabled
                            ></el-input>
                          </el-form-item>
                        </el-col>

                        <el-col :span="8">
                          <el-form-item label="Free Day:" prop="freeDays">
                            <el-input
                                size="mini"
                                case="upper"
                                v-model="ebOrder.freeDays"
                                :min="0"
                                disabled
                                onkeyup="value=value.replace(/[^\d]/g,'')"
                            ></el-input>
                          </el-form-item>
                        </el-col>
                      </el-row>
                    </el-col>
                    <el-col :span="8">
                      <el-row>
                        <el-col :span="12">
                          <el-form-item label="Free Status" prop="">
                            <el-select
                                class="length_input"
                                size="mini"
                                v-model="ebOrder.freeStatus"
                                :placeholder="$t('table.pleaseSelect')"
                                disabled
                            >
                              <el-option
                                  v-for="item in freeStatus"
                                  :key="item.key"
                                  :label="item.value"
                                  :value="item.key"
                              >
                              </el-option>
                            </el-select>
                          </el-form-item>
                        </el-col>

                        <el-col :span="12">
                          <el-form-item
                              label="Approval Status:"
                              prop="freeApprovalStatus"
                          >
                            <el-select
                                class="length_input"
                                size="mini"
                                v-model="ebOrder.freeApprovalStatus"
                                :placeholder="$t('table.pleaseSelect')"
                                disabled
                            >
                              <el-option
                                  v-for="item in approvalStatusList"
                                  :key="item.key"
                                  :label="item.value"
                                  :value="item.key"
                              >
                              </el-option>
                            </el-select>
                          </el-form-item>
                        </el-col>
                      </el-row>
                    </el-col>
                    <el-col :span="8">
                      <el-form-item label="Order Type:" prop="bizTypeName">
                        <el-associate
                            style="width: 100%"
                            :columns="associate_columns_bizTypeName"
                            :query-method="associate_queryMethod_bizTypeName"
                            class="input_length"
                            clearable
                            disabled
                            :query-length="0"
                            :default-first-option="true"
                            :label-prop="displayValue"
                            :value-prop="displayValue"
                            placeholder=""
                            v-model="ebOrder.bizTypeName"
                            size="mini"
                            @change="changeBizType"
                        />
                      </el-form-item>
                    </el-col>
                  </el-row>
                </el-col>
                <el-col>
                  <el-row :gutter="10">
                    <el-col :span="8">
                      <el-form-item
                          label="Contact:"
                          prop="custContact"
                          class="redItem"
                      >
                        <el-input
                            size="mini"
                            case="upper"
                            v-model="ebOrder.custContact"
                            ref="custContact"
                            disabled
                        ></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="8">
                      <el-form-item
                          label="Tel:"
                          prop="custContactTel"
                      >
                        <el-input
                            size="mini"
                            case="upper"
                            v-model="ebOrder.custContactTel"
                            disabled
                        ></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="8">
                      <el-form-item
                          label="Email:"
                          prop="custContactEmail"
                      >
                        <el-input
                            size="mini"
                            case="upper"
                            v-model="ebOrder.custContactEmail"
                            disabled
                        ></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </el-col>
         <!--        <el-col>
                  <el-row :gutter="10">
                    <el-col :span="8">
                      <el-form-item
                        label="订舱号:"
                        prop="bkMblNo"
                      >
                        <el-input
                          size="mini"
                          case="upper"
                          disabled
                          v-model="ebOrder.bkMblNo"
                          :title="ebOrder.bkMblNo"
                          ref="bkMblNo"
                        ></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="8">
                      <el-form-item
                        label="改配历史:"
                        prop="transferStatus"
                      >
                        <el-select
                          class="length_input"
                          size="mini"
                          v-model="ebOrder.transferStatus"
                          :placeholder="$t('table.pleaseSelect')"
                          disabled
                          clearable
                        >
                          <el-option
                            v-for="item in transferStatusList"
                            :key="item.key"
                            :label="item.value"
                            :value="item.key"
                          >
                          </el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </el-col> -->

<!--                 <el-col>
                  <el-row :gutter="10">
                    <el-col :span="20">
                      <el-row>
                        <el-col :span="21">
                          <el-checkbox-group
                              v-model="ebServiceItemList"
                              @change="onChangeEbServiceItem"
                          >
                            <el-checkbox
                                :label="item.key + '/' + item.value"
                                v-for="(item, index) in allEbServiceItems"
                                :key="index"
                            >
                              {{ item.value }}
                            </el-checkbox>
                          </el-checkbox-group>
                        </el-col>
                        <el-col :span="3">
                          <el-checkbox
                              label="拼箱"
                              v-model="ebOrder.isLcl"
                              :true-label="1"
                              :false-label="0"
                              @change="onChangeIsLcl"
                          ></el-checkbox>
                        </el-col>
                      </el-row>
                    </el-col>
                  </el-row>
                </el-col> -->
                <el-col>
                  <el-row :gutter="10">
                    <el-col :span="3" style="margin-right: -5%">
                      <el-form-item
                        label="Service："
                        class="redItem"
                      >
                      </el-form-item>
                    </el-col>
                    <el-col :span="28">
                      <el-checkbox-group
                        v-model="ebServiceItemList"
                        @change="onChangeEbServiceItem"
                        disabled
                      >
                        <el-checkbox
                          :label="item.key + '/' + item.value"
                          v-for="(item, index) in allEbServiceItems"
                          :key="index"
                        >
                          {{ item.value }}
                        </el-checkbox>
                      </el-checkbox-group>
                    </el-col>
                  </el-row>
                </el-col>
                <el-col style="margin-top: 8px">
                  <el-row :gutter="10">
                    <el-col :span="8">
                      <el-form-item
                          label="Carrier Sales:"
                          prop="carrierSales"
                      >
                        <el-input
                            size="mini"
                            case="upper"
                            v-model="ebOrder.carrierSales"
                            disabled
                        ></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="8">
                      <el-form-item
                          label="Branch:"
                          prop="settleOfficeName"
                      >
                        <el-associate
                            style="width: 100%"
                            :columns="associate_columns_csOffice"
                            :query-method="associate_queryMethod_csOffice"
                            class="input_length"
                            clearable
                            disabled
                            :query-length="0"
                            :default-first-option="true"
                            :label-prop="corpName"
                            value-prop="sysCorpId"
                            placeholder=""
                            v-model="ebOrder.settleOfficeName"
                            size="mini"
                            @change="changeCsOffice"
                        />
                      </el-form-item>
                    </el-col>
                    <el-col :span="8">
                      <el-form-item label="Customer Service:" prop="csName">
                        <el-associate
                            style="width: 100%"
                            :columns="associate_columns_csUser"
                            :query-method="associate_queryMethod_csUser"
                            class="input_length"
                            clearable
                            disabled
                            :query-length="0"
                            :default-first-option="true"
                            label-prop="salesNameCn"
                            value-prop="salesId"
                            placeholder=""
                            v-model="ebOrder.csName"
                            size="mini"
                            @change="onChangeCsOffice"
                            case="upper"
                        />
                      </el-form-item>
                    </el-col>
                  </el-row>
                </el-col>
                <el-col>
                  <el-row :gutter="10">
                    <el-col :span="8">
                      <el-form-item label="Email:" prop="csEmail">
                        <el-input
                            size="mini"
                            case="upper"
                            v-model="ebOrder.csEmail"
                            disabled
                        ></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="8">
                      <el-form-item label="Tel:" prop="csTel">
                        <el-input
                            size="mini"
                            case="upper"
                            v-model="ebOrder.csTel"
                            disabled
                        ></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="8">
                      <el-form-item label="Mobile:" prop="mobile">
                        <el-input
                            size="mini"
                            case="upper"
                            v-model="ebOrder.mobile"
                            disabled
                        ></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </el-col>
<!--                     <el-col>
                      <el-row :gutter="10">
                        <el-col :span="24">
                          <span class="more" @click="moreInfoVisible = !moreInfoVisible" style="float: right">More</span>
                        </el-col>
                      </el-row>
                    </el-col>
                    <div v-show="moreInfoVisible">
                      <el-col style="margin-top:8px;">
                        <el-row :gutter="10">
                          <el-col :span="8">
                            <el-form-item label="Carrier Sales:">
                              <el-input size="mini" case="upper" v-model="ebOrder.carrierSales"></el-input>
                            </el-form-item>
                          </el-col>
                          <el-col :span="8">
                            <el-form-item label="SettleOffice Name:" prop="settleOfficeName">
                              <el-associate style="width: 100%;"
                                            :columns="associate_columns_csOffice"
                                            :query-method="associate_queryMethod_csOffice"
                                            class="input_length"
                                            clearable
                                            :query-length="0"
                                            :default-first-option="true"
                                            label-prop="corpNameCn"
                                            value-prop="sysCorpId"
                                            placeholder=""
                                            v-model="ebOrder.settleOfficeName"
                                            size="mini"
                                            @change="changeCsOffice"
                              />
                            </el-form-item>
                          </el-col>
                          <el-col :span="8">
                            <el-form-item label="CsName:">
                              <el-associate style="width: 100%;"
                                            :columns="associate_columns_csUser"
                                            :query-method="associate_queryMethod_csUser"
                                            class="input_length"
                                            clearable
                                            :query-length="0"
                                            :default-first-option="true"
                                            label-prop="userNameCn"
                                            value-prop="sysUserId"
                                            placeholder=""
                                            v-model="ebOrder.csName"
                                            size="mini"
                                            @change="onChangeCsOffice"
                              />
                            </el-form-item>
                          </el-col>
                        </el-row>
                      </el-col>
                      <el-col>
                        <el-row :gutter="10">
                          <el-col :span="8">
                            <el-form-item label="CsEmail:">
                              <el-input size="mini" case="upper" v-model="ebOrder.csEmail" disabled></el-input>
                            </el-form-item>
                          </el-col>
                          <el-col :span="8">
                            <el-form-item label="CsTel:">
                              <el-input size="mini" case="upper" v-model="ebOrder.csTel" disabled></el-input>
                            </el-form-item>
                          </el-col>
                          <el-col :span="8">
                            <el-form-item label="CsMobile:">
                              <el-input size="mini" case="upper" v-model="ebOrder.mobile" disabled></el-input>
                            </el-form-item>
                          </el-col>
                        </el-row>
                      </el-col>
                    </div> -->
                  </el-row>
                </div>
                <!-- 基本信息-end -->

                <!-- 港口信息-start -->
                <div class="panel-top">
                  <el-row class="title-panel-external">
                  <div class="title-panel">
                    <el-col>
                      <span class="title-text">Port</span>
                    </el-col>
                  </div>
                  </el-row>
                  <el-row class="content-panel">
                    <el-col>
                      <el-row :gutter="10">
                        <el-col :span="12">
                          <el-row :gutter="5">
                            <el-col :span="12">
                              <el-form-item label="Place of Initial Receipt：">
                                <el-associate style="width: 100%;"
                                              :columns="associate_columns_po"
                                              :query-method="associate_queryMethod_po"
                                              class="input_length"
                                              clearable
                                              disabled
                                              :query-length="0"
                                              :default-first-option="true"
                                              label-prop="portNameEn"
                                              value-prop="portNameEn"
                                              placeholder=""
                                              v-model="ebOrder.porName"
                                              size="mini"
                                              @change="onChangePor"
                                />
                              </el-form-item>
                            </el-col>
                            <el-col :span="12">
                              <el-form-item>
                                <label slot="label" class="label_no"></label>
                                <el-input size="mini" case="upper" v-model="ebOrder.porCode" disabled></el-input>
                              </el-form-item>
                            </el-col>
                          </el-row>
                        </el-col>
                        <el-col :span="12">
                          <el-row :gutter="5">
                            <el-col :span="12">
                              <el-form-item label="Port of Loading：" prop="polName">
                                <el-associate style="width: 100%;"
                                              :columns="associate_columns_po"
                                              :query-method="associate_queryMethod_po"
                                              class="input_length"
                                              clearable
                                              disabled
                                              :query-length="0"
                                              :default-first-option="true"
                                              label-prop="portNameEn"
                                              value-prop="portNameEn"
                                              placeholder=""
                                              v-model="ebOrder.polName"
                                              size="mini"
                                              @change="onChangePol"
                                />
                              </el-form-item>
                            </el-col>
                            <el-col :span="12">
                              <el-form-item>
                                <label slot="label" class="label_no"></label>
                                <el-input size="mini" case="upper" v-model="ebOrder.polCode" disabled></el-input>
                              </el-form-item>
                            </el-col>
                          </el-row>
                        </el-col>
                      </el-row>
                    </el-col>
                    <el-col>
                      <el-row :gutter="10">
                        <el-col :span="12">
                          <el-row :gutter="5">
                            <el-col :span="12">
                              <el-form-item label="Port of Transit：">
                                <el-associate style="width: 100%;"
                                              :columns="associate_columns_po"
                                              :query-method="associate_queryMethod_po"
                                              class="input_length"
                                              clearable
                                              disabled
                                              :query-length="0"
                                              :default-first-option="true"
                                              label-prop="portNameEn"
                                              value-prop="portNameEn"
                                              placeholder=""
                                              v-model="ebOrder.potName"
                                              size="mini"
                                              @change="onChangePot"
                                />
                              </el-form-item>
                            </el-col>
                            <el-col :span="12">
                              <el-form-item>
                                <label slot="label" class="label_no"></label>
                                <el-input size="mini" case="upper" v-model="ebOrder.potCode" disabled></el-input>
                              </el-form-item>
                            </el-col>
                          </el-row>
                        </el-col>
                        <el-col :span="12">
                          <el-row :gutter="5">
                            <el-col :span="12">
                              <el-form-item label="Port of Discharge：" prop="podName">
                                <el-associate style="width: 100%;"
                                              :columns="associate_columns_po"
                                              :query-method="associate_queryMethod_po"
                                              class="input_length"
                                              clearable
                                              disabled
                                              :query-length="0"
                                              :default-first-option="true"
                                              label-prop="portNameEn"
                                              value-prop="portNameEn"
                                              placeholder=""
                                              v-model="ebOrder.podName"
                                              size="mini"
                                              @change="onChangePod"
                                />
                              </el-form-item>
                            </el-col>
                            <el-col :span="12">
                              <el-form-item>
                                <label slot="label" class="label_no"></label>
                                <el-input size="mini" case="upper" v-model="ebOrder.podCode" disabled></el-input>
                              </el-form-item>
                            </el-col>
                          </el-row>
                        </el-col>
                      </el-row>
                    </el-col>
                    <el-col>
                      <el-row :gutter="10">
                        <el-col :span="12">
                          <el-row :gutter="5">
                            <el-col :span="12">
                              <el-form-item label="Place of delivery：">
                                <el-associate style="width: 100%;"
                                              :columns="associate_columns_po"
                                              :query-method="associate_queryMethod_po"
                                              class="input_length"
                                              clearable
                                              disabled
                                              :query-length="0"
                                              :default-first-option="true"
                                              label-prop="portNameEn"
                                              value-prop="portNameEn"
                                              placeholder=""
                                              v-model="ebOrder.placeOfDeliveryName"
                                              size="mini"
                                              @change="onChangePlaceOfDelivery"
                                />
                              </el-form-item>
                            </el-col>
                            <el-col :span="12">
                              <el-form-item>
                                <label slot="label" class="label_no"></label>
                                <el-input size="mini" case="upper" v-model="ebOrder.placeOfDeliveryCode"
                                          disabled></el-input>
                              </el-form-item>
                            </el-col>
                          </el-row>
                        </el-col>
                        <el-col :span="12">
                           <el-form-item label="Transit Port Code：">
                            <el-input size="mini" case="upper" v-model="ebOrder.bargeTransitPortCode" disabled></el-input>
                          </el-form-item>
                        </el-col>
                      </el-row>
                    </el-col>
                  </el-row>
                </div>
                <!-- 港口信息-end -->
                <!-- 船期信息-start -->
                <div class="panel-top">
                <el-row class="title-panel-external">
                  <div class="title-panel">
                    <el-col>
                    <span class="title-text">Vsl/voy</span>
                  </el-col>
                  </div>
              </el-row>
                  <el-row class="content-panel">
                    <el-col>
                      <el-row :gutter="10">
                        <el-col :span="8">
                          <el-row>
                            <el-col :span="16">
                              <el-form-item label="Vsl/Voy：" prop="vesselNameEn">
                                <el-associate style="width: 100%;"
                                              :columns="associate_columns_vessel"
                                              :query-method="associate_queryMethod_vessel"
                                              class="input_length"
                                              clearable
                                              disabled
                                              :query-length="0"
                                              :default-first-option="true"
                                              label-prop="vesselName"
                                              value-prop="mdVoyagePlanId"
                                              placeholder=""
                                              v-model="ebOrder.vesselNameEn"
                                              size="mini"
                                              @change="onChangeVessel"
                                />
                              </el-form-item>
                            </el-col>
                            <el-col :span="8">
                              <el-form-item prop="voyage">
                                <label slot="label" class="label_no"></label>
                                <el-associate style="width: 100%;"
                                              :columns="associate_columns_voyage"
                                              :query-method="associate_queryMethod_voyage"
                                              class="input_length"
                                              clearable
                                              disabled
                                              :query-length="0"
                                              :default-first-option="true"
                                              label-prop="voyage"
                                              value-prop="mdVoyagePlanId"
                                              placeholder=""
                                              v-model="ebOrder.voyage"
                                              size="mini"
                                              @change="onChangeVoyage"
                                />
                              </el-form-item>
                            </el-col>
                          </el-row>
                        </el-col>
                        <el-col :span="8">
                          <el-form-item label="ETD：" prop="etd">
                            <el-date-picker
                              v-model="ebOrder.etd"
                              style="width:100%;"
                              align="right"
                              type="date"
                              size="mini"
                              placeholder="Select a date"
                              :picker-options="pickerOptions"
                              disabled>
                            </el-date-picker>
                          </el-form-item>
                        </el-col>
                        <el-col :span="8">
                          <el-form-item label="Area：">
                            <el-associate style="width: 100%;"
                                          :columns="associate_columns_terminal"
                                          :query-method="associate_queryMethod_terminal"
                                          class="input_length"
                                          clearable
                                          disabled
                                          :query-length="0"
                                          :default-first-option="true"
                                          :label-prop="custName"
                                          value-prop="csCustId"
                                          placeholder=""
                                          v-model="ebOrder.terminalName"
                                          size="mini"
                                          @change="onChangeTerminal"
                            />
                          </el-form-item>
                        </el-col>
                      </el-row>
                    </el-col>
                    <el-col>
                      <el-row :gutter="10">
                        <el-col :span="8">
                          <el-row>
                            <el-col :span="16">
                              <el-form-item label="Actual Vsl/Voy：">
                                 <el-associate style="width: 100%;"
                                                :columns="associate_columns_vessel"
                                                :query-method="associate_queryMethod_vessel"
                                                class="input_length"
                                                clearable
                                                :query-length="0"
                                                :default-first-option="true"
                                                label-prop="vesselNameEn"
                                                value-prop="mdVesselId"
                                                placeholder=""
                                                v-model="ebOrder.realVesselNameEn"
                                                size="mini"
                                                @change="onChangeRealVessel"
                                                disabled
                                />
<!--                                <el-input v-model="ebOrder.realVesselNameEn" size="mini" case="upper"
                                          disabled></el-input>-->
                              </el-form-item>
                            </el-col>
                            <el-col :span="8">
                              <el-form-item>
                                <label slot="label" class="label_no"></label>
                                 <el-associate style="width: 100%;"
                                                :columns="associate_columns_voyage"
                                                :query-method="associate_queryMethod_voyage"
                                                class="input_length"
                                                clearable
                                                :query-length="0"
                                                :default-first-option="true"
                                                label-prop="voyage"
                                                value-prop="voyage"
                                                placeholder=""
                                                v-model="ebOrder.realVoyage"
                                                size="mini"
                                                disabled
                                />
<!--                                <el-input v-model="ebOrder.realVoyage" case="upper" size="mini" disabled></el-input>-->
                              </el-form-item>
                            </el-col>
                          </el-row>
                        </el-col>
                        <el-col :span="8">
                          <el-form-item label="ATD:">
                             <el-date-picker
                                v-model="ebOrder.realEtd"
                                style="width:100%;"
                                align="right"
                                type="date"
                                size="mini"
                                placeholder="Select a date"
                                :picker-options="pickerOptions"
                                disabled
                             >
                            </el-date-picker>
<!--                            <el-input v-model="ebOrder.realEtd" case="upper" size="mini" disabled></el-input>-->
                          </el-form-item>
                        </el-col>
                        <el-col :span="8">
                          <el-form-item label="SI cut-off time：">
                             <el-date-picker
                                v-model="ebOrder.terminalTime"
                                align="right"
                                style="width:100%;"
                                type="date"
                                size="mini"
                                :placeholder="$t('table.selectTime')"
                                :picker-options="pickerOptions"
                                disabled
                             >
                            </el-date-picker>
<!--                            <el-input v-model="ebOrder.terminalTime" case="upper" size="mini" disabled></el-input>-->
                          </el-form-item>
                        </el-col>
                      </el-row>
                    </el-col>
                    <el-col>
                      <el-row :gutter="10">
                        <el-col :span="8">
                          <el-row>
                            <el-col :span="16">
                              <el-form-item label="Barge Vsl/Voy：">
                                <el-associate style="width: 100%;"
                                              :columns="associate_columns_vessel"
                                              :query-method="associate_queryMethod_vessel"
                                              class="input_length"
                                              clearable
                                              disabled
                                              :query-length="0"
                                              :default-first-option="true"
                                              label-prop="vesselNameEn"
                                              value-prop="mdVoyagePlanId"
                                              placeholder=""
                                              v-model="ebOrder.bargeVesselName"
                                              size="mini"
                                              @change="onChangeBargeVessel"
                                />
                              </el-form-item>
                            </el-col>
                            <el-col :span="8">
                              <el-form-item>
                                <label slot="label" class="label_no"></label>
                                <el-associate style="width: 100%;"
                                              :columns="associate_columns_voyage"
                                              :query-method="associate_queryMethod_voyage2"
                                              class="input_length"
                                              clearable
                                              disabled
                                              :query-length="0"
                                              :default-first-option="true"
                                              label-prop="voyage"
                                              value-prop="mdVoyagePlanId"
                                              placeholder=""
                                              v-model="ebOrder.bargeVoyage"
                                              size="mini"
                                />
                              </el-form-item>
                            </el-col>
                          </el-row>
                        </el-col>
                        <el-col :span="8">
                          <el-form-item label="Barge ETD：">
                            <el-date-picker
                              v-model="ebOrder.bargeEtd"
                              style="width:100%;"
                              align="right"
                              type="date"
                              size="mini"
                              placeholder="Select a date"
                              :picker-options="pickerOptions"
                              disabled>
                            </el-date-picker>
                          </el-form-item>
                        </el-col>
                        <el-col :span="8">
                          <el-form-item label="Barge Area：">
                            <el-associate style="width: 100%;"
                                          :columns="associate_columns_terminal"
                                          :query-method="associate_queryMethod_terminal"
                                          class="input_length"
                                          clearable
                                          disabled
                                          :query-length="0"
                                          :default-first-option="true"
                                          :label-prop="custName"
                                          :value-prop="custName"
                                          placeholder=""
                                          v-model="ebOrder.bargeTerminalName"
                                          size="mini"
                                          @change="onChangeBargeTerminal"
                            />
                          </el-form-item>
                        </el-col>
                      </el-row>
                    </el-col>
                  </el-row>
                </div>
                <!-- 船期信息-end -->
              </el-form>
            </el-col>
          </el-row>

          <!-- 货物信息与货物小计-start -->
          <el-row type="flex" justify="start" align="top">
            <el-col>
              <eb-cargo-info @getCargoInfo="getEbCargoInfo" :ebCargo="ebCargo" :ebOrder="ebOrder" editable="true" ref="ebCargoRef"/>
            </el-col>
          </el-row>
          <!-- 货物信息与货物小计-end -->

          <!--Attachment-->
<!--           <el-row class="panel-top">
            <el-col>
              <el-row class="title-panel-external">
                <div class="title-panel">
                  <el-col>
                  <span class="title-text">Attachment</span>
                </el-col>
                </div>
              </el-row>
              <el-row class="content-panel">
                <el-col>
                  <el-row>
                    <el-col :span="8">
                      <el-upload :before-upload="beforeAvatarUpload"
                                 :action="actionUrl"
                                 :on-success="handleAvatarSuccess"
                                 drag
                                 multiple
                                 :show-file-list="false"
                                 :file-list="fileList">
                        <i class="el-icon-upload"></i>
                        <div class="el-upload__text">
                          {{ $t('fileUpload.Drag') }}<em>{{ $t('fileUpload.clickToUpload') }}</em>
                          <div class="upload-font">
                            {{ $t('fileUpload.format') }}
                          </div>
                        </div>
                      </el-upload>
                    </el-col>
                    <el-col :span="15" :offset="1" style="border:1px solid #e4e4e4">
                      <div>
                        <el-table :data="ownFileDate"
                                  stripe
                                  height="200"
                                  highlight-current-row
                                  :row-style="{height:'0px'}"
                                  :cell-style="{padding:'0px'}"
                                  style="width:100%"
                                  tooltip-effect="light">
                          <el-table-column prop="fileName"
                                           min-width="160"
                                           :label="$t('fileUpload.fileName')"
                                           align="center"
                                           :show-overflow-tooltip="true">
                          </el-table-column>
                          <el-table-column prop="documentTypeCode"
                                           :label="$t('fileUpload.documentTypeCode')"
                                           align="center"
                          >
                            <template slot-scope="scope">
                              <el-select v-model="scope.row.documentTypeCode"
                                         :placeholder="$t('fileUpload.chooseDocumentTypeCode')"
                                         size="mini">
                                <el-option v-for="item in fileTypeList "
                                           :key="item.id"
                                           :label="item.name"
                                           :value="item.id">
                                </el-option>
                              </el-select>
                            </template>
                          </el-table-column>
                          <el-table-column :label="$t('fileUpload.operation')"
                                           align="center">
                            <template slot-scope="scope">
                              <el-row type="flex" justify="start" align="middle">
                                <el-col :span="4">
                                  <el-button size="mini"
                                             type="text"
                                             @click="handleDownLoad(scope.$index, scope.row)">
                                    {{ $t('fileUpload.download') }}
                                  </el-button>
                                </el-col>
                                <el-col :span="4" :offset="8">
                                  <el-button size="mini"
                                             type="text"
                                             @click="handleDelete(scope.$index, scope.row)"
                                             style="color:red">{{ $t('fileUpload.delete') }}
                                  </el-button>
                                </el-col>
                              </el-row>
                            </template>
                          </el-table-column>
                        </el-table>
                      </div>
                    </el-col>
                  </el-row>
                </el-col>
              </el-row>
            </el-col>
          </el-row> -->

          <!-- Container & Cargo -->
          <el-row class="panel-top form-panel-cargo">
              <el-row class="content-panel">
                <el-col>
                 <!--  <el-row class="content-panel position-parent" style="margin-top:10px" :gutter="10"> -->
                  <el-row :gutter="10">
                    <el-row class="title-panel-external blue-bg">
                      <div class="title-panel">
                        <el-col>
                          <span class="title-text">Cargo</span>
                        </el-col>
                      </div>
                    </el-row>
                    <!-- <span class="position-title">Cargo</span> -->
                    <el-row class="content-panel blue-bg">
                      <el-row class="panel-top  handsontable-set">
                        <hot-table
                          ref="CargoTableRef"
                          :data-source="CargoTableDataSource"
                          :settings="CargoTableSettings"
                          col-settings-key="Cargo"
                        >
                          <hot-column :has-tip="true" data="cargoDescription" title="Description of Cargo" width="150"></hot-column>
                          <hot-column :has-tip="true" data="noOfPackage" title="Qty" width="150"></hot-column>
                          <hot-column :has-tip="true" data="packageTypeName" title="Package" width="150"></hot-column>
                          <hot-column :has-tip="true" data="grossWeight" title="Gross Weight" width="150"></hot-column>
                          <hot-column :has-tip="true" data="cube" title="Measurement" width="150"></hot-column>
                          <hot-column :has-tip="true" data="netWeight" title="Net Weight" width="150"></hot-column>
                          <hot-column :has-tip="true" data="hsCode" title="HS CODE" width="150"></hot-column>
                          <hot-column :has-tip="true"
                                      data="isHazard"
                                      title="Hazard"
                                      width="150"
                                      type="checkbox"
                                      disabled
                                      className="htCenter"
                                      :checked-template="1"
                                      :unchecked-template="0"
                                      checked-display="是"
                                      unchecked-display="否">
                            <el-input-editor hot-editor name="isReefer" case="upper" disabled />
                          </hot-column>
                          <hot-column :has-tip="true"
                                      data="isReefer"
                                      title="Reffer"
                                      width="150"
                                      type="checkbox"
                                      disabled
                                      className="htCenter"
                                      :checked-template="1"
                                      :unchecked-template="0"
                                      checked-display="是"
                                      unchecked-display="否">
                            <el-input-editor hot-editor name="isReefer" case="upper" disabled />
                          </hot-column>
                          <hot-column :has-tip="true"
                                      data="isBulkyCargo"
                                      title="Bulk"
                                      width="150"
                                      type="checkbox"
                                      disabled
                                      className="htCenter"
                                      :checked-template="1"
                                      :unchecked-template="0"
                                      checked-display="是"
                                      unchecked-display="否">
                            <el-input-editor hot-editor name="isBulkyCargo" case="upper" disabled />
                          </hot-column>
                        </hot-table>
                        <!-- 分页start -->
                        <!--                    <div class="pg_div" style="margin-bottom:8px">-->
                        <!--                      <el-pagination-->
                        <!--                        :current-page="pageConfig.currentPage"-->
                        <!--                        :layout="pageConfig.layout"-->
                        <!--                        :page-size="pageConfig.pageSize"-->
                        <!--                        :page-sizes="pageConfig.pageSizes"-->
                        <!--                        :total="pageConfig.total"-->
                        <!--                        @current-change="handleCurrentChange"-->
                        <!--                        @size-change="handleSizeChange"-->
                        <!--                      />-->
                        <!--                    </div>-->
                      </el-row>
                    </el-row>
                  </el-row>
                </el-col>>
              </el-row>
          </el-row>
                  <el-row class="panel-top form-panel-cargo">
                    <el-row class="content-panel">
                      <el-col>
                        <el-row :gutter="10">
                        <el-row class="title-panel-external blue-bg">
                          <div class="title-panel">
                            <el-col>
                            <span class="title-text">Container</span>
                            </el-col>
                          </div>
                        </el-row>
                    <!-- <span class="position-title">Container</span> -->
                    <el-row class="content-panel blue-bg">
                       <el-row class="panel-top  handsontable-set">
                    <hot-table
                      ref="ContainerTableRef"
                      :data-source="ContainerTableDataSource"
                      :settings="ContainerTableSettings"
                      col-settings-key="Container"
                    >
                      <hot-column :has-tip="true" data="ctnNo" title="Container No." width="150"></hot-column>
                      <hot-column :has-tip="true" data="sealNo" title="Seal No." width="150"></hot-column>
                      <hot-column :has-tip="true" data="ctnSizeType" title="Ctn Size" width="150"></hot-column>
                      <hot-column :has-tip="true" data="noOfPackage" title="Qty" width="150"></hot-column>
                      <hot-column :has-tip="true" data="packageName" title="Package" width="150"></hot-column>
                      <hot-column :has-tip="true" data="cube" title="Measurement" width="150"></hot-column>
                      <hot-column :has-tip="true" data="grossWeight" title="Gross Weight" width="150"></hot-column>
                      <hot-column :has-tip="true" data="netWeight" title="Net Weight" width="150"></hot-column>
                      <hot-column :has-tip="true" data="tareWeight" title="Tare Weight" width="150"></hot-column>
                    </hot-table>

                    <!-- 分页start -->
<!--                    <div class="pg_div" style="margin-bottom:8px">-->
<!--                      <el-pagination-->
<!--                        :current-page="pageConfig.currentPage"-->
<!--                        :layout="pageConfig.layout"-->
<!--                        :page-size="pageConfig.pageSize"-->
<!--                        :page-sizes="pageConfig.pageSizes"-->
<!--                        :total="pageConfig.total"-->
<!--                        @current-change="handleCurrentChange"-->
<!--                        @size-change="handleSizeChange"-->
<!--                      />-->
<!--                    </div>-->
                    </el-row>
                  </el-row>
                  </el-row>

                </el-col>
              </el-row>
<!--            </el-col>-->
          </el-row>

                    <!--Addition and Remarks-->
          <el-row type="flex" justify="start" align="top" class="panel-top">
            <el-col>
              <el-row :gutter="10">
                <el-col :span="10" style="padding:0 16px 0 5px">
               <el-row class="title-panel-external">
                <div class="title-panel">
                  <el-col>
                  <span class="title-text">Addition</span>
                </el-col>
                </div>
              </el-row>
                  <el-row class="content-panel" style="min-height: 200px;margin-bottom:0px">
                      <el-col v-if="carrierExpand.length > 0">
                      <el-row :gutter="10">
                        <el-col :span="12" v-for="(widgetItem ,index) in carrierExpand" :key="index">
                          <el-form-item :label="widgetItem.fieldName" v-if="widgetItem.controlType === '01'">
                            <el-select class="length_input" size="mini" v-model="bookingForm[widgetItem.fieldCode]"
                                       :placeholder="$t('table.pleaseSelect')">
                              <el-option
                                v-for="item in carrierSelectList[widgetItem.controlBindCode]"
                                :key="item.key"
                                :label="item.value"
                                :value="item.key"
                              >
                              </el-option>
                            </el-select>
                          </el-form-item>
                          <el-form-item :label="widgetItem.fieldName" v-if="widgetItem.controlType === '02'">
                            <el-input size="mini" v-model="bookingForm[widgetItem.fieldCode]"
                                      placeholder="请输入"></el-input>
                          </el-form-item>
                        </el-col>
                      </el-row>
                      <el-row :gutter="10">
                        <el-col :span="12">
                          <el-form-item label="Agreement Type:">
                            <el-select class="length_input" size="mini" v-model="bookingForm.agreement_type"
                                       placeholder="Please Select">
                              <el-option
                                v-for="item in options"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value"
                              >
                              </el-option>
                            </el-select>
                          </el-form-item>
                        </el-col>
                        <el-col :span="12">
                          <el-form-item label="POD attribute:">
                            <el-select class="length_input" size="mini" v-model="bookingForm.POD_attribute"
                                       placeholder="Please select">
                              <el-option
                                v-for="item in options"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value"
                              >
                              </el-option>
                            </el-select>
                          </el-form-item>
                        </el-col>
                      </el-row>
                      <el-row :gutter="10">
                        <el-col :span="12">
                          <el-form-item label="POD Transport:">
                            <el-select class="length_input" size="mini" v-model="bookingForm.clause"
                                       placeholder="Please select">
                              <el-option
                                v-for="item in options"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value"
                              >
                              </el-option>
                            </el-select>
                          </el-form-item>
                        </el-col>
                        <el-col :span="12">
                          <el-form-item label="POD Zip Code:">
                            <el-input size="mini" v-model="bookingForm.zip_Code"></el-input>
                          </el-form-item>
                        </el-col>
                      </el-row>

                    </el-col>
                   <el-col class="icon-wrp" v-else>
                     <img class="icon-none-info" :src="icon_none_info" alt="" />
                      <div class="txt-none-info">暂无船公司扩展信息</div>
                  </el-col>
                  </el-row>
                </el-col>
                <el-col :span="14" style="padding:0 5px 0 0">

              <el-row class="title-panel-external">
                <div class="title-panel">
                  <el-col>
                  <span class="title-text">Remarks</span>
                </el-col>
                </div>
              </el-row>
                  <el-row class="content-panel" style="margin-bottom:0px;min-height: 200px;">
                    <el-col>
                      <el-row :gutter="10">
                        <el-col :span="12">
                          <el-form-item label="Customer Remarks:">
                            <el-input
                              size="mini"
                              type="textarea"
                              case="upper"
                              :rows="7"
                              disabled
                              v-model="ebOrder.orderRemark">
                            </el-input>
                          </el-form-item>
                        </el-col>
                        <el-col :span="12">
                          <el-form-item label="Reuturn Remarks:">
                            <el-input
                              size="mini"
                              type="textarea"
                              :rows="7"
                              case="upper"
                              disabled
                              v-model="ebOrder.bookingFeedBack">
                            </el-input>
                          </el-form-item>
                        </el-col>
                      </el-row>
                    </el-col>
                  </el-row>
                </el-col>
              </el-row>
            </el-col>
          </el-row>
        </el-form>
      </el-row>
      <el-row class="btn-container panel-top" type="flex" justify="end" align="middle">
        <el-button type="primary" size="small" plain @click="closeTab">Close</el-button>
        <el-button type="primary" size="small" plain @click="printTab">Print</el-button>
      </el-row>
      <el-dialog
        :visible.sync="mdReportTemplateVisible"
        title="打印"
        :append-to-body="true"
        :close-on-click-modal="true"
        width="70%"
      >
        <el-row>
          <el-button class="el-button-search" type="primary" size="small" plain @click="preview()" >Preview</el-button>
          <el-button class="el-button-search" type="primary" size="small" plain   >Print</el-button>
        </el-row>
        <el-row style="margin-top: 15px;margin-bottom: 20px;height: 300px">
          <hot-table
            ref="mdReportTemplateTableRef"
            :data-source="mdReportTemplateData"
            col-settings-key="onlineServiceDialogTable"
          >
            <hot-column :has-tip="true" data="templateNameCn" title="套版名称" width="150"></hot-column>
          </hot-table>
        </el-row>
      </el-dialog>
    </el-form>
  </div>
</template>

<script>
import ScrollPane from '@/layout/components/TagsView/ScrollPane'
import {bookingFormRules} from "@/rules/booking_rules";
import ebCargoInfoEn from "@/components/EbCargoInfo/EbCargoInfoEn";
import ebPartyInfoEn from "@/components/EbPartyInfo/EbPartInfoEn";
import mdCodeDict from "@/api/mdCodeDict";
import {
  getBookingVO,
  saveBookingDTO,
  submitBookingDTO,
  saveAndSub,
  getCarrierInfoStr,
  getOrderdata,
  deleteEbCtnRequest,
  revokeSub
} from "@/api/bookingRequest";
import {
  queryCarrierInfo,
  queryCtnCompanyInfo,
  queryCtnSizeInfo, queryDictionaryByCodeType,
  queryDictRows,
  queryPoInfo,
  querySysCorpInfo,
  querySysUserInfo,
  queryVesselInfo,
  queryVoyageInfo
} from "@/api/commonService";
import { queryDSRDetail } from '@/api/overseas'
import { ebCtnRequestValidate } from "@/rules/rules";
import saveTemplateUpBox from "@/views/booking/SaveTemplateUpBox";
import changeHistoryUpBox from "@/views/booking/ChangeHistoryUpBox";
import ebCtnRequest from "@/api/ebCtnRequest";
import { batchUpdateOrderStatus } from "@/api/bookingRequest";
import sysCorpCust from "@/api/sysCorpCust";
import { set } from 'js-cookie';
import {queryMdReportTemplate} from "@/api/common";

export default {
  name: 'DsrDetail',
  components: {
    ScrollPane,
    ebCargoInfo: ebCargoInfoEn,
    ebPartyInfo: ebPartyInfoEn,
    save_template_up_box: saveTemplateUpBox,
    change_history_up_box: changeHistoryUpBox,
  },
  data() {
    return {
      rebizTypeName: '',
      resettleOfficeName: '',
      mdReportTemplateVisible: false,
      mdReportTemplateData: [],
      recsName: '',
      displayValue: 'displayValueCn',
      custName: 'custNameCn',
      corpName: 'corpNameCn',
      icon_none_info: require("../../assets/images/dashboard_imgs/shipping-company.png"),
      DsrDetailForm: {},
      collapseActive: [0, 1, 2],
      icon1: require('@/assets/img/status/status11.png'),
      icon2: require('@/assets/img/status/status3.png'),
      icon3: require('@/assets/img/status/status3.png'),
      icon4: require('@/assets/img/status/status10.png'),
      icon5: require('@/assets/img/status/status10.png'),
      icon6: require('@/assets/img/status/status10.png'),
      axisStatusList: [
        {
          completeStatus: 0,
          statusName: 'Draft',
          statusCreateTime: '2021-07-15 23:21',
        },
        {
          completeStatus: 1,
          statusName: 'Submit Booking',
          statusCreateTime: '2021-07-16 15:21',
        },
        {
          completeStatus: 2,
          statusName: 'Booking Success',
          statusCreateTime: '2021-07-16 17:21',
        },
        {
          completeStatus: 3,
          statusName: 'BC Sent',
          statusCreateTime: '2021-07-17 12:42',
        },
        {
          completeStatus: 4,
          statusName: 'Manifest Sent',
          statusCreateTime: '2021-07-18 12:42',
        },
        {
          completeStatus: 5,
          statusName: 'BL Confirmed',
          statusCreateTime: '2021-07-19 12:42',
        },

      ],
      groupStatusVos: [
        {
          name: '订舱状态',
          statusList: [
            {
              name: '已发订舱',
              status_time: '2019-07-12 13:21',
              status_detail: '[客户委托号：CUST23945-31]已发订舱',
              data_sources: '华贸主系统',
              inside: '内部',
              recording_time: '2019-07-12 13:21'
            },
            {
              name: '订舱更改中',
              status_time: '2019-07-12 13:35',
              status_detail: '[客户委托号：CUST0123945-31]订舱更改中',
              data_sources: '华贸主系统',
              inside: '内部',
              recording_time: '2019-07-12 13:35'
            }
          ]
        },
        {
          name: '放箱状态',
          statusList: [
            {
              name: '已放箱',
              status_time: '2019-07-13 15:56',
              status_detail: '提单号：APUD20393454，箱号CPUG0342514，已完成下发计划信息',
              data_sources: '华贸主系统',
              inside: '内部',
              recording_time: '2019-07-12 13:21'
            },
            {
              name: '空箱出场',
              status_time: '2019-07-15 23:21',
              status_detail: '提单号：APUD20393454已空箱出场，车牌号：苏A82848，箱号：CPUG0342514',
              data_sources: '华贸主系统',
              inside: '内部',
              recording_time: '2019-07-12 13:21'
            },
            {
              name: '重箱进场',
              status_time: '2019-07-18 06:34',
              status_detail: '提单号：APUD20393454已重箱进场，车牌号：苏A82848，箱号：CPUG0342514',
              data_sources: '华贸主系统',
              inside: '内部',
              recording_time: '2019-07-12 13:35'
            }
          ]
        },
        {
          name: '订舱更改',
          statusList: [
            {
              name: '订舱更改',
              status_time: '2019-07-12 13:21',
              status_detail: '提单号：APUD20393454，船名已更改: 旧值: ：KAI TONG 98, 新值 KAI TONG 99',
              data_sources: '华贸主系统',
              inside: '内部',
              recording_time: '2019-07-12 13:21'
            },
            {
              name: '订舱更改',
              status_time: '2019-07-12 13:35',
              status_detail: '提单号：APUD20393454，船名已更改为：KAI TONG 88 ; 航次已更改为：1926W',
              data_sources: '华贸主系统',
              inside: '内部',
              recording_time: '2019-07-12 13:35'
            }
          ]
        },
      ],
      // 记录进入页面次数
      bookingCount: 0,
      //存为模板弹出框
      saveTemplateVisible: false,
      //改配历史弹出框
      changeHistoryVisible: false,
      //所有的格式化订舱数据
      allBookingDTO: {},
      //服务项勾选
      ebServiceItemList: [],
      //订单
      ebOrder: {
        mblTransportTermFrom: "CY",
        mblTransportTermTo: "CY",
        issueMode: "O", //正本提单
        noOfOriginal: "3", //THREE(3)
        noOfCopy: "0", //ZERO(0)
        custContact: "",
        custContactTel: "",
        custContactEmail: "",
        orderStatus: "NEW",
        ebOrderStatus: "New",
        bizTypeCode: "MFEF",
        bizTypeName: "海运整箱出口",
        bizBigTypeCode: "MFE",
        bizBigTypeName: "海运集装整箱出口",
        inputMethond: "M",
        orderType: "F",
        isCancelApply: 0,
        // custId: "1",//登录人的委托单位
        // custName: "",//登录人的委托单位
        isLcl: 0,
        // carrierId: "1", //根据对话框中选择的船公司赋值?
        carrierName: "", //根据对话框中选择的船公司赋值?
        isDeleted: 0,
        vgmStatus: "UNSENT",
        vgmApprovalStatus: "NEW",
        transferStatus: 0,
        rowStatus: 4,
        ctnNum: '',
        settleOfficeName: '',
        voyage: '',
        bargeVoyage: '',
        mblPaymentType: '',
        mblPaymentPlace: '',
        placeOfIssueName: '',
        freeStorage: '',
        freeOfDetention: '',
        freeStatus: '',
        carrierSales: '',
        porName: '',
        polName: '',
        podName: '',
        potName: '',
        placeOfDeliveryName: '',
        bargeTransitPortCode: '',
        bookingFeedBack: '',
        orderRemark: ''
      },
      //货物信息
      ebCargo: {
        ebCargoD: [
          // {
          //   totalFlag: "D",
          //   isHazard: 0,
          //   isReefer: 0,
          //   isBulkyCargo: 0,
          //   isDeclare: 0,
          //   isOceanPollution: 0,
          //   rowStatus: 4,
          // },
        ],
        ebCargoM: {
          totalFlag: "M",
          isHazard: 0,
          isReefer: 0,
          isBulkyCargo: 0,
          isDeclare: 0,
          isOceanPollution: 0,
          rowStatus: 4,
          hazardClass: "1.1",
          flashPointUnit: "C",
          temperatureUnit: "C"
        },
        //删除的ebCargo
        ebCargoDelete: [],
      },
      //预配箱
      ebCtnRequests: [],
      //预配箱明细
      ebCtnRequestDetails: [],
      //服务项
      ebServiceItems: [],
      //收发通信息
      ebParty: {
        //发货人
        ebPartySH: {partyType: "SH", rowStatus: 4},
        //收获人
        ebPartyCN: {partyType: "CN", rowStatus: 4, partyDescription: ""},
        //通知人
        ebPartyNT: {partyType: "NT", rowStatus: 4, partyDescription: ""},
        //第二通知人
        ebPartyNT2: {partyType: "NT2", rowStatus: 4},
        //真实发货人
        ebPartyRSH: {partyType: "RSH", rowStatus: 4},
        //真实收获人
        ebPartyRCN: {partyType: "RCN", rowStatus: 4},
        //真实通知人
        ebPartyRNT: {partyType: "RNT", rowStatus: 4},
      },
      //删除的ebCtnRequestDetail
      ebCtnRequestDetailDelete: [],
      //删除的ebCtnRequest
      ebCtnRequestDelete: [],
      //付款方式
      mblPaymentTypeList: [],
      //运输条款
      mblTransportTermList: [],
      //签单方式
      issueModeList: [],
      //正本份数、副本份数
      noOfOriginalList: [],
      // 状态
      freeStatus: [],
      //所有的服务项
      allEbServiceItems: [],
      //华贸分公司联想控件
     associate_columns_csOffice: [
        {
          title: this.$t("associate.code"),
          field: "sysCorpId",
        },
        {
          title: this.$t("associate.fullCN"),
          field: "corpNameCn",
        },
      ],
      //华贸客服联想控件
      associate_columns_csUser: [
        {
          title: this.$t("associate.userCode"),
          field: "userCode",
        },
        {
          title: this.$t("associate.portNameCn"),
          field: "userNameCn",
        },
        {
          title: this.$t("associate.portNameEn"),
          field: "userNameEn",
        },
      ],
      //箱型联想控件
      associate_columns_ctnSizeType: [
        {
          title: this.$t("associate.boxTypeSize"),
          field: "containerType",
        },
      ],
      //箱公司联想控件
      associate_columns_ctnCompany: [
        {
          title: this.$t("associate.custAlias"),
          field: "custAlias",
        },
        {
          title: this.$t("associate.consignorName"),
          field: "custNameCn",
        },
        {
          title: this.$t("associate.mnemonicCode"),
          field: "mnemonicCode",
        },
      ],
      //大船/驳船船名联想控件
      associate_columns_vessel: [
        {
          title: this.$t("associate.vesselName"),
          field: "vesselName",
        },
        {
          title: this.$t("associate.voyage"),
          field: "voyage",
        },
      ],
      //航次联想控件
      associate_columns_voyage: [
        {
          title: this.$t("associate.vesselName"),
          field: "vesselName",
        },
        {
          title: this.$t("associate.voyage"),
          field: "voyage",
        },
        {
          title: this.$t("associate.voyageCode"),
          field: "voyageCode",
        },
      ],
      //(驳船)作业码头联想控件
      associate_columns_terminal: [
        {
          title: this.$t("associate.custAlias"),
          field: "custAlias",
        },
        {
          title: this.$t("associate.consignorName"),
          field: "custNameCn",
        },
        {
          title: this.$t("associate.mnemonicCode"),
          field: "mnemonicCode",
        },
      ],
      //Branch联想控件
      associate_columns_Branch(){

      },
      //收货地/装货港/中转港/卸货港/交货地联想控件
      associate_columns_po: [
        {
          title: this.$t("associate.portNameEn"),
          field: "portNameEn",
        },
        {
          title: this.$t("associate.portNameCn"),
          field: "portNameCn",
        },
        {
          title: this.$t("associate.countryCode"),
          field: "countryCode",
        },
        {
          title: this.$t("associate.portCode"),
          field: "portCode",
        },
      ],
      //业务要素联想控件
      associate_columns_bizTypeName: [
        {
          title: this.$t("associate.typeOfService"),
          field: "displayValueCn",
        },
        {
          title: this.$t("associate.codeValue"),
          field: "codeValue",
        },
      ],
      //表单校验
      bookingFormRules: {
        ...bookingFormRules,
        etd: [
          {
            required: true,
            message: "Ship sailing date cannot be blank",
            trigger: "blur",
          },
        ],
        bargeVesselName: [
          {
            validator: this.twoNotNullInThreeBarge,
            trigger: "blur",
          },
        ],
        bargeVoyage: [
          {
            validator: this.twoNotNullInThreeBarge,
            trigger: "blur",
          },
        ],
        bargeEtd: [
          {
            validator: this.twoNotNullInThreeBarge,
            trigger: "blur",
          },
        ],
      },
      boxVisible: true,
      moreInfoVisible: false,
      bookingForm: {
        POD_attribute: "",
        agreement_type: "",
        bookingNum: "",
        bill_lading_num: "",
        payType: "",
        payer: "",
        zip_Code: "",
        pay_place: "",
        clause: "",
        sc: "",
        na: "",
        signing_method: "",
        signing_place: "",
        copies_chief: "",
        copies_deputy: "",
        contacts: "",
        contact_number: "",
        email: "",
        checkList: [],
        etd: "",
        customerNotes: "",
        feedbackNotes: "",
      },
      pickerOptions: {
        // disabledDate(time) {
        //   return time.getTime() > Date.now();
        // },
        shortcuts: [
          {
            text: "Today",
            onClick(picker) {
              picker.$emit("pick", new Date());
            },
          },
          {
            text: "Yesterday",
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24);
              picker.$emit("pick", date);
            },
          },
          {
            text: "A week ago",
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", date);
            },
          },
        ],
      },
      // 预配箱信息
      ebCtnRequestRules: {}, //预配箱信息校验规则
      // 预配箱信息表格配置
      ebCtnRequestSettings: {
        height: 180,
        autoColumnSize: true,
        stretchH: "none", // 根据宽度横向扩展，last:只扩展最后一列，none：默认不扩展
        afterChange: this.afterChangeEbCtnRequest,
        ...this.$systemConfig.tableConfig,
      },
      ebCtnRequestDetailRules: {}, //预配箱明细校验规则
      // 预配箱明细表格配置
      ebCtnRequestDetailSettings: {
        height: 220,
        autoColumnSize: true,
        stretchH: "none", // 根据宽度横向扩展，last:只扩展最后一列，none：默认不扩展
        afterChange: this.afterChangeEbCtnRequestDetail,
        ...this.$systemConfig.tableConfig,
      },
      cargoInfoForm: {
        checkList: [],
        shippingMark: "父向子传值", //唛头
        cargoDetail: "", //货物描述
        pieces: "",
        package: "",
        grossWeight: "", //毛重
        volume: "", //体积
        netWeight: "", //净重
        hsCode: "",
        cargoInfoArr: [0],
      },
      // Json
      eiOrderJson: {},
      isSaveNew: false,
      ebParams: {},
      saveNewVisible: false,
      submitVisible: false,
      // 船公司
      associate_columns_carrier: [
        {
          title: this.$t("associate.custAlias"),
          field: "custAlias",
        },
        {
          title: this.$t("associate.consignorName"),
          field: "custNameCn",
        },
        {
          title: this.$t("associate.mnemonicCode"),
          field: "mnemonicCode",
        },
      ],
      carrierExpand: [],
      carrierSelectList: {},
      ebServiceItemsBuffer: [],
      // 分页
      pageConfig: {
        layout: 'total, sizes, prev, pager, next, jumper',
        total: 0,
        pageSize: 10,
        pagerCount: 10,
        currentPage: 1,
        pageSizes: [10, 20, 50, 100]
      },
      _index: 0,
      // 表格数据
      ContainerTableDataSource: [],
      // 表格设置
      ContainerTableSettings: {
        height: 220,
        stretchH: "all", // 根据宽度横向扩展，last:只扩展最后一列，none：默认不扩展
        ...this.$systemConfig.tableConfig,
      },
      // 表格数据
      CargoTableDataSource: [],
      // 表格设置
      CargoTableSettings: {
        height: 220,
        stretchH: "all", // 根据宽度横向扩展，last:只扩展最后一列，none：默认不扩展
        ...this.$systemConfig.tableConfig,
      },
    };
  },
  async created() {

  },
  mounted() {
    let _this = this;
      if(this.$cookies.get('language')==='en'){
     this.displayValue = 'displayValueEn'
     this.custName = 'custNameEn'
     this.corpName = 'corpNameEn'
     this.associate_columns_carrier= [
        {
          title: this.$t("associate.custAlias"),
          field: "custAlias",
        },
        {
          title: this.$t("associate.consignorName"),
          field: "custNameEn",
        },
        {
          title: this.$t("associate.mnemonicCode"),
          field: "mnemonicCode",
        },
      ],
        this.associate_columns_terminal= [
        {
          title: this.$t("associate.custAlias"),
          field: "custAlias",
        },
        {
          title: this.$t("associate.consignorName"),
          field: "custNameEn",
        },
        {
          title: this.$t("associate.mnemonicCode"),
          field: "mnemonicCode",
        },
      ]
       this.associate_columns_bizTypeName= [
        {
          title: this.$t("associate.typeOfService"),
          field: "displayValueEn",
        },
        {
          title: this.$t("associate.codeValue"),
          field: "codeValue",
        },
      ]
      this.associate_columns_csOffice= [
        {
          title: this.$t("associate.code"),
          field: "sysCorpId",
        },
        {
          title: this.$t("associate.fullEN"),
          field: "corpNameEn",
        },
      ]
      }
    if(this.$route.query.goOrderId){
    var data ={
        goOrderId: this.$route.query.goOrderId
      }
      queryDSRDetail(data).then((result) => {
        console.log(result)
        var goPartys = result.records.goPartys
       _this.ebParty.ebPartySH = goPartys.filter((item) => { return item.partyType === "SH" })[0];
       _this.ebParty.ebPartyCN = goPartys.filter((item) => { return item.partyType === "CN" })[0];
       _this.ebParty.ebPartyNT = goPartys.filter((item) => { return item.partyType === "NT" })[0];
       _this.ebParty.ebPartyNT2 = goPartys.filter((item) => { return item.partyType === "NT2" })[0];
       _this.ebParty.ebPartyRSH = goPartys.filter((item) => { return item.partyType === "RSH" })[0];
       _this.ebParty.ebPartyRCN = goPartys.filter((item) => { return item.partyType === "RCN" })[0];
       _this.ebParty.ebPartyRNT = goPartys.filter((item) => { return item.partyType === "RNT" })[0];
       _this.ebOrder = result.records.mfOrder;
       if(result.records.goContact){
         _this.ebOrder.custContact = result.records.goContact.custContact;
         _this.ebOrder.custContactEmail = result.records.goContact.custContactEmail;
         _this.ebOrder.custContactTel = result.records.goContact.custContactTel;
       }
       _this.ebOrder.csEmail = result.records.csEmail;
       _this.ebOrder.csTel = result.records.csTel;
       _this.ebOrder.mobile = result.records.csMobilePhone;
        _this.ebServiceItems = result.records.goServiceItems;
        _this.ebServiceItems.forEach((item) => {
          let label = item.planCode + "/" + item.planName;
          _this.ebServiceItemList.push(label);
        });
       _this.ebCtnRequests = result.records.goCtnRequests
       _this.ebCtnRequestDetails = result.records.goCtns
        _this.ContainerTableDataSource = result.records.goCtns;
      _this.ebCargo.ebCargoM = result.records.goCargos.filter((item) => { return item.totalFlag === "M" })[0];
      _this.ebCargo.ebCargoD = result.records.goCargos.filter((item) => { return item.totalFlag === "D" })[0];
      _this.CargoTableDataSource = result.records.goCargos.filter((item) => { return item.totalFlag === "D" });
     if(this.$cookies.get('language')==='en'){
        var pageSize = 10
        var currentPage = 1
        this.rebizTypeName = 'false'
        var keyword = this.ebOrder.bizTypeName
        this.associate_queryMethod_bizTypeName({ keyword, pageSize, currentPage })
        this.resettleOfficeName = 'false'
        var settleOfficeName = this.ebOrder.settleOfficeName
        this.associate_queryMethod_csOffice({ settleOfficeName, pageSize, currentPage })
        this.recsName = 'false'
        keyword = this.ebOrder.csName
        this.associate_queryMethod_csUser({ keyword, pageSize, currentPage })
    }
      })
    }
    _this.ebOrderType = sessionStorage.getItem('ebOrderType')
    let userInfo = JSON.parse(localStorage.getItem('userInfo'))
    _this.ebOrder.custContact = userInfo.userNameCn;
    //数据字典
    _this.getSelectList();
    _this.queryEbServiceItems();
    //预配箱信息表格校验
    _this.ebCtnRequestRules = ebCtnRequestValidate();
    //表格响应式
    _this.resizeObserver = new ResizeObserver((entries) => {
      _this.$nextTick(() => {
        _this.$refs.ContainerTableRef.resizeTo(
          entries[0].target.clientWidth - 19
        );
        _this.$refs.CargoTableRef.resizeTo(
          entries[0].target.clientWidth - 19
        );
      });
    });
    _this.resizeObserver.observe(document.getElementById("boxDiv1"));
  },
  beforeDestroy() {
    let _this = this;
    // 离开页面删除检测器和所有侦听器
    _this.resizeObserver.disconnect();
  },
  methods: {
    //打印方法
    printTab() {
      let self = this;
      self.mdReportTemplateVisible= true;
      //查询套版
      let searchData = {
        apiKey : "CTS_ILP_MdReportTemplate",
        sqlKey: "CTS_ILP_MdReportTemplate",
        tag: "CTS_ILP_MdReportTemplate",
        reqArgs: {"templateTypeCode": ""},
        action: "query",
        returnTotal: false
      }
      queryMdReportTemplate(searchData).then((res) => {
        console.log("queryTemplate", res);
        if (res.success == true ) {
          self.mdReportTemplateData = res.data;
          // if (res.data.length === 0){
          //   self.$coreMethods.message("warning", "没有数据，请重新输入查询条件！");
          // }else {
          //   self.$coreMethods.message("success", "查询成功！");
          // }
        }
      });
    },
    preview(){
      let self = this;
      if(self.$refs.mdReportTemplateTableRef.getSelections().length==1){

        if(self.$refs.mdReportTemplateTableRef.getSelected().reportUrl==null){
          self.$coreMethods.message("error", this.$t('message.pleaseCheck'));
          return;
        }

        self.mdReportTemplateVisible= false;
        self.$router.push({
          name: "reportShow",
          query: {
            systemType: self.$refs.mdReportTemplateTableRef.getSelected().systemType,
            reportUrl: self.$refs.mdReportTemplateTableRef.getSelected().reportUrl,
            primaryId: self.reportPrimaryId
          }
        });
      }else {
        self.$coreMethods.message("warning", this.$t('message.selectAData'));
      }
    },
    //关闭界面并返回上一级页面
    closeTab() {
      this.$store.state.tagsView.visitedViews.splice(
        this.$store.state.tagsView.visitedViews.findIndex(
          (item) => item.path === this.$route.path
        ),
        1
      );
      // this.$router.push(
      //   {
      //     path: "/agency/DsrQuery",
      //   }
      // );
      this.$router.push(
        this.$store.state.tagsView.visitedViews[
        this.$store.state.tagsView.visitedViews.length - 1
          ].path
      );
    },
          //业务类型数据服务
    associate_queryMethod_bizTypeName({keyword, pageSize, currentPage}) {
      let self = this;

      let whereParams = "";

      if (keyword === "") {
        whereParams = mdCodeDict.codeType
          .eq$("EB_MD_BUSSINESS_TYPE")
          .and(mdCodeDict.isActive.eq$(1))
          .and(mdCodeDict.isDeleted.eq$(0));
      } else {
        whereParams = mdCodeDict.codeValue
          .like$("%" + keyword + "%")
          .or(mdCodeDict.displayValueCn.like$("%" + keyword + "%"))
          .and(mdCodeDict.isActive.eq$(1))
          .and(mdCodeDict.isDeleted.eq$(0))
          .and(mdCodeDict.codeType.eq$("EB_MD_BUSSINESS_TYPE"));
      }
      let params = {
        whereObj: whereParams,
        page: currentPage,
        limit: pageSize,
      };
      return new Promise((resolve) => {
        mdCodeDict
          .queryMdCodeDict(params)
          .then((res) => {
            if (res.success) {
              resolve({
                records: res.data.data,
                total: res.data.totalRecord,
              });
             if(this.$cookies.get('language')==='en'&& this.rebizTypeName === 'false'){
               this.ebOrder.bizTypeName = res.data.data[0].displayValueEn
                this.rebizTypeName = 'true'
              }
            }
          })
          .catch((err) => {
            console.log(err);
          });
      });
    },
    // 签单方式
    changeIssueMode(val) {
      console.log('val', val)
      // 正本 O 01 电放 T 02 SWB: S 03
      if (val === 'O') {
        this.ebOrder.noOfOriginal = '3'
        this.ebOrder.noOfCopy = '0'
      } else if (val === 'T') {
        this.ebOrder.noOfOriginal = '0'
        this.ebOrder.noOfCopy = '0'
      } else if (val === 'S') {
        this.ebOrder.noOfOriginal = '1'
        this.ebOrder.noOfCopy = '0'
      } else {
        this.ebOrder.noOfOriginal = '3'
        this.ebOrder.noOfCopy = '3'
      }
    },
    // 船公司联想控件数据源
    associate_queryMethod_carrier({keyword, pageSize, currentPage}) {
      let params = {};
      if (keyword === "") {
        params = {
          custType4: "%SO%",
          isDeleted6: "0",
          isBlacklist: "0",
        };
      } else {
        params = {
          custAlias0: "%" + keyword + "%",
          custNameCn1: "%" + keyword + "%",
          custType4: "%SO%",
          isDeleted6: "0",
          isBlacklist: "0",
          mdmCustCode3: "%" + keyword + "%",
          mnemonicCode2: "%" + keyword + "%",
        };
      }

      let data = {
        action: "query",
        crudType: "SELECT",
        sorting: ["CTS_ILPCsCust.custNameCn"],
        mainModelName: "CTS_ILPCsCust",
        tag: "CTS_WEB_es",
        where: "(((((CTS_ILPCsCust.custAlias LIKE :custAlias0 OR CTS_ILPCsCust.custNameCn LIKE :custNameCn1) ) AND CTS_ILPCsCust.esCustType LIKE :custType4) ) AND CTS_ILPCsCust.isDeleted = :isDeleted6)",
        currentPage: currentPage,
        pageSize: pageSize,
        returnPage: true,
        returnTotal: false,
        reqArgs: params,
        fields: [
          "CTS_ILPCsCust.csCustId",
          "CTS_ILPCsCust.custAlias",
          "CTS_ILPCsCust.custNameCn",
          "CTS_ILPCsCust.custNameEn",
          "CTS_ILPCsCust.customsRegisteredNo",
          "CTS_ILPCsCust.esCustType",
          "CTS_ILPCsCust.isActive",
          "CTS_ILPCsCust.isBlacklist",
          "CTS_ILPCsCust.isCustomer",
          "CTS_ILPCsCust.isDeleted",
          "CTS_ILPCsCust.isOneTimeCustomer",
          "CTS_ILPCsCust.isSettlement",
          "CTS_ILPCsCust.isSupplier",
          "CTS_ILPCsCust.legalPerson",
          "CTS_ILPCsCust.mdmCustCode",
          "CTS_ILPCsCust.mobileNo",
          "CTS_ILPCsCust.postCode"
        ],
        enableCascade: true
      };
      return new Promise((resolve) => {
        queryCarrierInfo(data).then((res) => {
          console.log("queryCarrierInfo", res);
          resolve({
            records: res.data.data,
            total: res.data.totalRecord,
          });
        });
      }).catch((err) => {
        console.log(err);
      });
    },
    //大船船名、航次、开航日期3个必输2
    twoNotNullInThree(rule, value, callback) {
      let self = this;
      let data = [
        self.ebOrder.vesselNameEn,
        self.ebOrder.voyage,
        self.ebOrder.etd,
      ];
      let i = 0;
      data.forEach((item) => {
        if (item !== "" && item !== null && item !== undefined) {
          i = i + 1;
        }
      });
      if (i < 2) {
        callback(new Error("船名/航次/开航日期必输2个"));
      }
      callback();
    },
    //驳船船名、航次、开航日期3个必输2
    twoNotNullInThreeBarge(rule, value, callback) {
      let self = this;
      console.log("self.ebOrder.bargeVesselName", self.ebOrder.bargeVesselName);
      let data = [
        self.ebOrder.bargeVesselName,
        self.ebOrder.bargeVoyage,
        self.ebOrder.bargeEtd,
      ];
      let i = 0;
      data.forEach((item) => {
        if (item !== "" && item !== null && item !== undefined) {
          i = i + 1;
        }
      });
      if (i < 2) {
        callback(new Error("驳船船名/航次/开航日期必输2个"));
      }
      callback();
    },
    //初始化界面根据ebOrderId获取界面数据
    getBookingDataByEbOrderIdAndFlag(ebOrderId, flag) {
      let params = {
        ebOrderId: ebOrderId,
        flag: flag,
      };
      let self = this;
      getBookingVO(params).then((res) => {
        console.log("getBookingVO:", res);
        if (res.success) {
          let data = res.data;
          //货物信息
          let ebCargoMap = eval("(" + JSON.stringify(data.ebCargoMap) + ")");
          self.ebCargo.ebCargoM = ebCargoMap.ebCargoM[0];
          self.ebCargo.ebCargoD = ebCargoMap.ebCargoD;
          //预配箱
          self.ebCtnRequests = data.ebCtnRequests;
          //预配箱明细
          self.ebCtnRequestDetails = data.ebCtnRequestDetails;
          //服务项
          self.ebServiceItems = data.ebServiceItems;
          self.ebServiceItems.forEach((item) => {
            let label = item.serviceCode + "/" + item.serviceName;
            self.ebServiceItemList.push(label);
          });
          console.log("ebServiceItemList:", self.ebServiceItemList);
          //收发通信息
          let ebPartyMap = eval("(" + JSON.stringify(data.ebPartyMap) + ")");
          self.ebParty = {
            ebPartySH: ebPartyMap.SH,
            ebPartyCN: ebPartyMap.CN,
            ebPartyNT: ebPartyMap.NT,
            ebPartyRSH: ebPartyMap.RSH,
            ebPartyRCN: ebPartyMap.RCN,
            ebPartyRNT: ebPartyMap.RNT,
          };
        }
      });
    },
    //获取数据字典
    getSelectList() {
      let self = this;
      let params={
      codeType: "PAYMENTMODE;TRANSPORT_TERM;ISSUE_TYPE;MD_BK_NO_OF_BILL;ARG_TYPE;EB_MD_CODE_SERVICE_REQUEST;FREE_CTN_STATUS",
		  valueType: 'ZH',
        }
		 if(this.$cookies.get('language')==='en'){
		  params={
      codeType: "PAYMENTMODE;TRANSPORT_TERM;ISSUE_TYPE;MD_BK_NO_OF_BILL;ARG_TYPE;EB_MD_CODE_SERVICE_REQUEST;FREE_CTN_STATUS",
		  valueType: 'EN',
        }
		 }
       queryDictionaryByCodeType(params).then((res) => {
        /*name:value value:key*/
        console.log("queryDictRows:", res);
        //付款方式
        self.mblPaymentTypeList = res.records.PAYMENTMODE;
        //运输条款
        self.mblTransportTermList = res.records.TRANSPORT_TERM;
        //签单方式
        self.issueModeList = res.records.ISSUE_TYPE;
        //正本份数、副本份数
        self.noOfOriginalList = res.records.MD_BK_NO_OF_BILL;
        // 状态
        self.freeStatus = res.records.FREE_CTN_STATUS;
        //所有服务项
        // self.allEbServiceItems = res.MD_CODE_DICT$EB_MD_CODE_SERVICE_REQUEST;
        //协议类型-船公司扩展信息
        //目的地属性-船公司扩展信息
        //目的地运输方式-船公司扩展信息
      });
    },
    //查询所有服务项
    queryEbServiceItems() {
      let self = this;
      let params={
        codeType: "EB_MD_CODE_SERVICE_REQUEST",
        valueType: 'ZH'
      }
      if(this.$cookies.get('language')==='en'){
		  params={
        codeType: "EB_MD_CODE_SERVICE_REQUEST",
        valueType: 'EN',
        }
		 }
      queryDictionaryByCodeType(params).then((res) => {
        let dict = [];
        res.records.EB_MD_CODE_SERVICE_REQUEST.forEach((item) => {
          let param = {};
          param.value = item.value;
          param.key = item.key;
          dict.push(param);
        });
        self.allEbServiceItems = dict;
        console.log("allEbServiceItems", dict);
      });
    },
    //Branch联想控件数据源
    associate_queryMethod_Branch({keyword, pageSize, currentPage}){

    },
    // 收货地/装货港/中转港/卸货港/交货地联想控件数据源
    associate_queryMethod_po({keyword, pageSize, currentPage}) {
      let params = {};
      if (keyword === "") {
        params = {
          portType4: ["OP", "IP"],
          isDeleted5: "0",
          isActive: "1"
        };
      } else {
        params = {
          portNameEn0: "%" + keyword + "%",
          portNameCn1: "%" + keyword + "%",
          countryCode2: "%" + keyword + "%",
          portCode3: "%" + keyword + "%",
          portType4: ["OP", "IP"],
          isDeleted5: "0",
          isActive: "1"
        };
      }

      let data = {
        action: "query",
        crudType: "SELECT",
        sorting: ["CTS_ILPMdPort.portNameEn"],
        mainModelName: "CTS_ILPMdPort",
        tag: "CTS_ILP_es",
        where:
          "(((((CTS_ILPMdPort.portNameEn LIKE :portNameEn0 OR CTS_ILPMdPort.portNameCn LIKE :portNameCn1) OR CTS_ILPMdPort.countryCode LIKE :countryCode2) OR CTS_ILPMdPort.portCode LIKE :portCode3) AND CTS_ILPMdPort.portType IN( :portType4)) AND CTS_ILPMdPort.isDeleted = :isDeleted5 AND CTS_ILPMdPort.isActive = :isActive)",
        currentPage: currentPage,
        pageSize: pageSize,
        returnPage: true,
        returnTotal: false,
        reqArgs: params,
        fields: [
          "CTS_ILPMdPort.mdPortId",
          "CTS_ILPMdPort.createOffice",
          "CTS_ILPMdPort.lastModifyOffice",
          "CTS_ILPMdPort.lastModifyOfficeName",
          "CTS_ILPMdPort.lastModifierId",
          "CTS_ILPMdPort.areaCode",
          "CTS_ILPMdPort.lineNameCn",
          "CTS_ILPMdPort.portNameEn",
          "CTS_ILPMdPort.principalGroupCode",
          "CTS_ILPMdPort.customsCode",
          "CTS_ILPMdPort.isActive",
          "CTS_ILPMdPort.createOfficeName",
          "CTS_ILPMdPort.creatorName",
          "CTS_ILPMdPort.lastModifierName",
          "CTS_ILPMdPort.appCode",
          "CTS_ILPMdPort.longitude",
          "CTS_ILPMdPort.creatorId",
          "CTS_ILPMdPort.recordVersion",
          "CTS_ILPMdPort.lastModifyTime",
          "CTS_ILPMdPort.portNameCn",
          "CTS_ILPMdPort.portCode",
          "CTS_ILPMdPort.createTime",
          "CTS_ILPMdPort.isDeleted",
          "CTS_ILPMdPort.iataCode",
          "CTS_ILPMdPort.latitude",
          "CTS_ILPMdPort.lineId",
          "CTS_ILPMdPort.countryName",
          "CTS_ILPMdPort.countryCode",
          "CTS_ILPMdPort.portType",
        ],
        enableCascade: true,
      };
      return new Promise((resolve) => {
        queryPoInfo(data).then((res) => {
          console.log("res", res);
          resolve({
            records: res.data.data,
            total: parseInt(res.data.totalRecord),
          });
        });
      }).catch((err) => {
        console.log(err);
      });
    },
    // 华贸分公司联想控件数据源
    associate_queryMethod_csOffice({keyword, pageSize, currentPage}) {
      let self = this;
      let userInfo = JSON.parse(localStorage.getItem('userInfo'));
      let params = {
        page: self.pageConfig.currentPage,
        limit: self.pageConfig.pageSize,
        csCustId: userInfo.custId,
      };
      if (keyword !== "") {
        params.corpNameCn = keyword
      }
      return new Promise((resolve) => {
        sysCorpCust.getsysCorpCustCsOffice(params).then((res) => {
          resolve({
            records: res.data.data,
            total: res.data.length,
          });
           if(this.$cookies.get('language')==='en'&& this.resettleOfficeName === 'false'){
          this.ebOrder.settleOfficeName = res.data.data[0].corpNameEn
          this.resettleOfficeName = 'true'
        }
        });
      }).catch((err) => {
        console.log(err);
      });
      // if (keyword === "") {
      //   params = {
      //     isDeleted3: "0",
      //   };
      // } else {
      //   params = {
      //     corpCode0: "%" + keyword + "%",
      //     corpName1: "%" + keyword + "%",
      //     corpNameCn2: "%" + keyword + "%",
      //     isDeleted3: "0",
      //   };
      // }

      // let data = {
      //   action: "query",
      //   crudType: "SELECT",
      //   sorting: ["CTS_ILPSysCorp.corpNameCn"],
      //   mainModelName: "CTS_ILPSysCorp",
      //   tag: "CTS_ILP_es",
      //   where:
      //     "(((CTS_ILPSysCorp.corpCode LIKE :corpCode0 OR CTS_ILPSysCorp.corpName LIKE :corpName1) OR CTS_ILPSysCorp.corpNameCn LIKE :corpNameCn2) AND CTS_ILPSysCorp.isDeleted = :isDeleted3)",
      //   currentPage: 1,
      //   pageSize: 10,
      //   returnPage: true,
      //   returnTotal: false,
      //   reqArgs: params,
      //   fields: [
      //     "CTS_ILPSysCorp.sysCorpId",
      //     "CTS_ILPSysCorp.contactMode",
      //     "CTS_ILPSysCorp.gtReviewer",
      //     "CTS_ILPSysCorp.unionpayMerchantNo",
      //     "CTS_ILPSysCorp.gtPayee",
      //     "CTS_ILPSysCorp.recordVersion",
      //     "CTS_ILPSysCorp.addressCn",
      //     "CTS_ILPSysCorp.baseCurrencyCode",
      //     "CTS_ILPSysCorp.tel",
      //     "CTS_ILPSysCorp.settleAccount",
      //     "CTS_ILPSysCorp.lastModifierId",
      //     "CTS_ILPSysCorp.contactPerson",
      //     "CTS_ILPSysCorp.corpNameEn",
      //     "CTS_ILPSysCorp.corpCode",
      //     "CTS_ILPSysCorp.isActive",
      //     "CTS_ILPSysCorp.businessRegisterNo",
      //     "CTS_ILPSysCorp.corpShortCode",
      //     "CTS_ILPSysCorp.parentOfficeId",
      //     "CTS_ILPSysCorp.corpName",
      //     "CTS_ILPSysCorp.corpType",
      //     "CTS_ILPSysCorp.appCode",
      //     "CTS_ILPSysCorp.createTime",
      //     "CTS_ILPSysCorp.lastModifyOffice",
      //     "CTS_ILPSysCorp.lastModifyOfficeName",
      //     "CTS_ILPSysCorp.isDeleted",
      //     "CTS_ILPSysCorp.bankAccount",
      //     "CTS_ILPSysCorp.createOffice",
      //     "CTS_ILPSysCorp.creatorId",
      //     "CTS_ILPSysCorp.createOfficeName",
      //     "CTS_ILPSysCorp.financiaCode",
      //     "CTS_ILPSysCorp.corpNameCn",
      //     "CTS_ILPSysCorp.lastModifierName",
      //     "CTS_ILPSysCorp.principalGroupCode",
      //     "CTS_ILPSysCorp.mailingAddress",
      //     "CTS_ILPSysCorp.depositBank",
      //     "CTS_ILPSysCorp.remark",
      //     "CTS_ILPSysCorp.lastModifyTime",
      //     "CTS_ILPSysCorp.creatorName",
      //     "CTS_ILPSysCorp.addressEn",
      //     "CTS_ILPSysCorp.parentOfficeName",
      //     "CTS_ILPSysCorp.invoiceQuota",
      //     "CTS_ILPSysCorp.systemRate",
      //   ],
      //   enableCascade: true,
      // };
      // return new Promise((resolve) => {
      //   querySysCorpInfo(data).then((res) => {
      //     console.log("querySysCorpInfo", res);
      //     resolve({
      //       records: res.data.data,
      //       total: res.data.totalRecord,
      //     });
      //   });
      // }).catch((err) => {
      //   console.log(err);
      // });
    },
    // 华贸客服联想控件数据源
    associate_queryMethod_csUser({keyword, pageSize, currentPage}) {
      let params = {};
      if (keyword === "") {
        params = {
          isDeleted3: "0",
          isActive: "1"
        };
      } else {
        params = {
          userName0: "%" + keyword + "%",
          userNameCn1: "%" + keyword + "%",
          userNameEn2: "%" + keyword + "%",
          isDeleted3: "0",
          isActive: "1"
        };
      }

      let data = {
        action: "query",
        crudType: "SELECT",
        sorting: ["CTS_ILPSysUser.userNameCn"],
        mainModelName: "CTS_ILPSysUser",
        tag: "CTS_ILP_es",
        where:
          "(((CTS_ILPSysUser.userName LIKE :userName0 OR CTS_ILPSysUser.userNameCn LIKE :userNameCn1) OR CTS_ILPSysUser.userNameEn LIKE :userNameEn2) AND CTS_ILPSysUser.isDeleted = :isDeleted3 AND CTS_ILPSysUser.isActive = :isActive)",
        currentPage: currentPage,
        pageSize: pageSize,
        returnPage: true,
        returnTotal: false,
        reqArgs: params,
        fields: [
          "CTS_ILPSysUser.sysUserId",
          "CTS_ILPSysUser.appCode",
          "CTS_ILPSysUser.activeEndTime",
          "CTS_ILPSysUser.activeStartTime",
          "CTS_ILPSysUser.dataAuthorityName",
          "CTS_ILPSysUser.defaultCorpCode",
          "CTS_ILPSysUser.isSuperAdmin",
          "CTS_ILPSysUser.domainAccount",
          "CTS_ILPSysUser.createOffice",
          "CTS_ILPSysUser.tel",
          "CTS_ILPSysUser.email",
          "CTS_ILPSysUser.lastLoginSettleOfficeName",
          "CTS_ILPSysUser.recordVersion",
          "CTS_ILPSysUser.remark",
          "CTS_ILPSysUser.isPasswordModify",
          "CTS_ILPSysUser.principalGroupCode",
          "CTS_ILPSysUser.qq",
          "CTS_ILPSysUser.passwordModifyTime",
          "CTS_ILPSysUser.creatorName",
          "CTS_ILPSysUser.lastModifyOfficeName",
          "CTS_ILPSysUser.lastLoginOfficeName",
          "CTS_ILPSysUser.defaultOffice",
          "CTS_ILPSysUser.lastModifyTime",
          "CTS_ILPSysUser.fax",
          "CTS_ILPSysUser.dataAuthorityId",
          "CTS_ILPSysUser.settleOffice",
          "CTS_ILPSysUser.userType",
          "CTS_ILPSysUser.lastLoginOffice",
          "CTS_ILPSysUser.userCode",
          "CTS_ILPSysUser.ipAddress",
          "CTS_ILPSysUser.defaultCorpName",
          "CTS_ILPSysUser.identityCardNo",
          "CTS_ILPSysUser.password",
          "CTS_ILPSysUser.mobilePhone",
          "CTS_ILPSysUser.settleOfficeName",
          "CTS_ILPSysUser.emailPassword",
          "CTS_ILPSysUser.age",
          "CTS_ILPSysUser.macAddress",
          "CTS_ILPSysUser.userSource",
          "CTS_ILPSysUser.userName",
          "CTS_ILPSysUser.wechat",
          "CTS_ILPSysUser.lastModifierName",
          "CTS_ILPSysUser.sex",
          "CTS_ILPSysUser.isActive",
          "CTS_ILPSysUser.lastModifierId",
          "CTS_ILPSysUser.createTime",
          "CTS_ILPSysUser.creatorId",
          "CTS_ILPSysUser.domainPassword",
          "CTS_ILPSysUser.defaultLanguage",
          "CTS_ILPSysUser.defaultOfficeName",
          "CTS_ILPSysUser.lastModifyOffice",
          "CTS_ILPSysUser.createOfficeName",
          "CTS_ILPSysUser.inserviceStatus",
          "CTS_ILPSysUser.isDeleted",
          "CTS_ILPSysUser.userNameCn",
          "CTS_ILPSysUser.lastLoginSettleOffice",
          "CTS_ILPSysUser.userNameEn",
        ],
        enableCascade: true,
      };

      return new Promise((resolve) => {
        querySysUserInfo(data).then((res) => {
          console.log("querySysUserInfo", res);
          resolve({
            records: res.data.data,
            total: res.data.totalRecord,
          });
          if(this.$cookies.get('language')==='en'&& this.recsName === 'false'){
          this.ebOrder.csName = res.data.data[0].userNameEn
          this.recsName = 'true'
        }
        });
      }).catch((err) => {
        console.log(err);
      });
    },
    // 箱型尺寸联想控件数据源
    associate_queryMethod_ctnSizeType({keyword, pageSize, currentPage}) {
      let params = {};
      if (keyword === "") {
        params = {
          isDeleted2: "0",
          isActive: "1"
        };
      } else {
        params = {
          isDeleted0: "%" + keyword + "%",
          containerType1: "%" + keyword + "%",
          isDeleted2: "0",
          isActive: "1"
        };
      }

      let data = {
        action: "query",
        crudType: "SELECT",
        sorting: ["CTS_ILPMdContainerType.containerType"],
        mainModelName: "CTS_ILPMdContainerType",
        tag: "CTS_ILP_es",
        where:
          "((CTS_ILPMdContainerType.isDeleted LIKE :isDeleted0 OR CTS_ILPMdContainerType.containerType LIKE :containerType1) AND CTS_ILPMdContainerType.isDeleted = :isDeleted2 AND CTS_ILPMdContainerType.isActive = :isActive)",
        currentPage: currentPage,
        pageSize: pageSize,
        returnPage: true,
        returnTotal: false,
        reqArgs: params,
        fields: [
          "CTS_ILPMdContainerType.mdContainerTypeId",
          "CTS_ILPMdContainerType.containerTypeName",
          "CTS_ILPMdContainerType.recordVersion",
          "CTS_ILPMdContainerType.ctnHeight",
          "CTS_ILPMdContainerType.principalGroupCode",
          "CTS_ILPMdContainerType.lastModifierId",
          "CTS_ILPMdContainerType.ctnWeight",
          "CTS_ILPMdContainerType.lastModifyOffice",
          "CTS_ILPMdContainerType.creatorName",
          "CTS_ILPMdContainerType.createOffice",
          "CTS_ILPMdContainerType.teu",
          "CTS_ILPMdContainerType.isActive",
          "CTS_ILPMdContainerType.creatorId",
          "CTS_ILPMdContainerType.createTime",
          "CTS_ILPMdContainerType.lastModifyOfficeName",
          "CTS_ILPMdContainerType.ctnWidth",
          "CTS_ILPMdContainerType.containerSize",
          "CTS_ILPMdContainerType.lastModifyTime",
          "CTS_ILPMdContainerType.ctnDescriptionEn",
          "CTS_ILPMdContainerType.ctnDescriptionCn",
          "CTS_ILPMdContainerType.maxWeight",
          "CTS_ILPMdContainerType.containerType",
          "CTS_ILPMdContainerType.ctnLength",
          "CTS_ILPMdContainerType.lastModifierName",
          "CTS_ILPMdContainerType.isDeleted",
          "CTS_ILPMdContainerType.appCode",
          "CTS_ILPMdContainerType.maxMeas",
          "CTS_ILPMdContainerType.reamrk",
          "CTS_ILPMdContainerType.createOfficeName",
        ],
        enableCascade: true,
      };
      return new Promise((resolve) => {
        queryCtnSizeInfo(data).then((res) => {
          console.log("queryCtnSizeInfo", res);
          resolve({
            records: res.data.data,
            total: res.data.totalRecord,
          });
        });
      }).catch((err) => {
        console.log(err);
      });
    },
    // 箱公司联想控件数据源
    associate_queryMethod_ctnCompany({keyword, pageSize, currentPage}) {
      let params = {};
      if (keyword === "") {
        params = {
          isDeleted3: "0",
          settleOffice4: [
            "6602234090773020672",
            "6790513595064000512",
            "6787571144657547264",
            "6789083706284920832",
            "6791246552603078656",
            "6791246897089654784",
            "6791903283037388800",
            "6791903451522580480",
            "6792333596855156736",
          ],
          custType5: "%CO%",
          // isBlacklist6: "0",
          isActive: "1"
        };
      } else {
        params = {
          custAlias0: "%" + keyword + "%",
          custNameCn1: "%" + keyword + "%",
          mnemonicCode2: "%" + keyword + "%",
          isDeleted3: "0",
          settleOffice4: [
            "6602234090773020672",
            "6790513595064000512",
            "6787571144657547264",
            "6789083706284920832",
            "6791246552603078656",
            "6791246897089654784",
            "6791903283037388800",
            "6791903451522580480",
            "6792333596855156736",
          ],
          custType5: "%CO%",
          // isBlacklist6: "0",
          isActive: "1"
        };
      }

      let data = {
        action: "query",
        crudType: "SELECT",
        sorting: ["CTS_ILPCsCust.custNameCn"],
        mainModelName: "CTS_ILPCsCust",
        tag: "CTS_WEB_es",
        where: "(((((CTS_ILPCsCust.custAlias LIKE :custAlias0 OR CTS_ILPCsCust.custNameCn LIKE :custNameCn1) ) AND CTS_ILPCsCust.esCustType LIKE :custType4) ) AND CTS_ILPCsCust.isDeleted = :isDeleted6)",
        currentPage: currentPage,
        pageSize: pageSize,
        returnPage: true,
        returnTotal: false,
        reqArgs: params,
        fields: [
          "CTS_ILPCsCust.csCustId",
          "CTS_ILPCsCust.custAlias",
          "CTS_ILPCsCust.custNameCn",
          "CTS_ILPCsCust.custNameEn",
          "CTS_ILPCsCust.customsRegisteredNo",
          "CTS_ILPCsCust.esCustType",
          "CTS_ILPCsCust.isActive",
          "CTS_ILPCsCust.isBlacklist",
          "CTS_ILPCsCust.isCustomer",
          "CTS_ILPCsCust.isDeleted",
          "CTS_ILPCsCust.isOneTimeCustomer",
          "CTS_ILPCsCust.isSettlement",
          "CTS_ILPCsCust.isSupplier",
          "CTS_ILPCsCust.legalPerson",
          "CTS_ILPCsCust.mdmCustCode",
          "CTS_ILPCsCust.mobileNo",
          "CTS_ILPCsCust.postCode"
        ],
        enableCascade: true
      };
      return new Promise((resolve) => {
        queryCtnCompanyInfo(data).then((res) => {
          console.log("queryCtnCompanyInfo", res);
          resolve({
            records: res.data.data,
            total: res.data.totalRecord,
          });
        });
      }).catch((err) => {
        console.log(err);
      });
    },
    // 船名联想控件数据源
    associate_queryMethod_vessel({keyword, pageSize, currentPage}) {
      let params = {};
      if (keyword === "") {
        params = {
          isDeleted2: "0",
        };
      } else {
        params = {
          vesselName0: "%" + keyword + "%",
          voyage1: "%" + keyword + "%",
        };
      }

      let data = {
        action: "query",
        crudType: "SELECT",
        sorting: ["CTS_ILPMdVoyagePlan.voyage"],
        mainModelName: "CTS_ILPMdVoyagePlan",
        tag: "CTS_ILP_es",
        where:
          "(((CTS_ILPMdVoyagePlan.voyage LIKE :voyage1 OR CTS_ILPMdVoyagePlan.vesselName LIKE :vesselName0)) AND CTS_ILPMdVoyagePlan.isDeleted = :isDeleted2)",
        currentPage: currentPage,
        pageSize: pageSize,
        returnPage: true,
        returnTotal: false,
        reqArgs: params,
        fields: [
          "CTS_ILPMdVoyagePlan.mdVoyagePlanId",
          "CTS_ILPMdVoyagePlan.createTime",
          "CTS_ILPMdVoyagePlan.principalGroupCode",
          "CTS_ILPMdVoyagePlan.customsVesselName",
          "CTS_ILPMdVoyagePlan.lastModifyTime",
          "CTS_ILPMdVoyagePlan.isDeleted",
          "CTS_ILPMdVoyagePlan.remark",
          "CTS_ILPMdVoyagePlan.recordVersion",
          "CTS_ILPMdVoyagePlan.voyage",
          "CTS_ILPMdVoyagePlan.voyageCode",
          "CTS_ILPMdVoyagePlan.createOffice",
          "CTS_ILPMdVoyagePlan.customsVoyage",
          "CTS_ILPMdVoyagePlan.vesselId",
          "CTS_ILPMdVoyagePlan.appCode",
          "CTS_ILPMdVoyagePlan.createOfficeName",
          "CTS_ILPMdVoyagePlan.creatorName",
          "CTS_ILPMdVoyagePlan.creatorId",
          "CTS_ILPMdVoyagePlan.customsVesselId",
          "CTS_ILPMdVoyagePlan.lastModifyOfficeName",
          "CTS_ILPMdVoyagePlan.lastModifyOffice",
          "CTS_ILPMdVoyagePlan.lastModifierName",
          "CTS_ILPMdVoyagePlan.ioFlag",
          "CTS_ILPMdVoyagePlan.carrierId",
          "CTS_ILPMdVoyagePlan.lastModifierId",
          "CTS_ILPMdVoyagePlan.vesselName",
          "CTS_ILPMdVoyagePlan.carrierName",
        ],
        enableCascade: true,
      };
      return new Promise((resolve) => {
        queryVoyageInfo(data).then((res) => {
          console.log("res", res);
          resolve({
            records: res.data.data,
            total: parseInt(res.data.totalRecord),
          });
        });
      }).catch((err) => {
        console.log(err);
      });
    },
    // 航次联想控件数据源
    associate_queryMethod_voyage({keyword, pageSize, currentPage}) {
      let params = {};
      let whereObj = null
      if (keyword === "") {
        params = {
          isDeleted3: "0",
        };
      } else {
        params = {
          isDeleted3: "0",
          vesselName0: "%" + keyword + "%",
          voyage1: "%" + keyword + "%",
          voyageCode2: "%" + keyword + "%",
        };
      }

      if (this.ebOrder.vesselNameEn) {
        params.vesselId = this.ebOrder.vesselId
        whereObj = "(((CTS_ILPMdVoyagePlan.vesselName LIKE :vesselName0 OR CTS_ILPMdVoyagePlan.voyage LIKE :voyage1) OR CTS_ILPMdVoyagePlan.voyageCode LIKE :voyageCode2) AND CTS_ILPMdVoyagePlan.isDeleted = :isDeleted3 AND CTS_ILPMdVoyagePlan.vesselId = :vesselId)"
      } else {
        whereObj = "(((CTS_ILPMdVoyagePlan.vesselName LIKE :vesselName0 OR CTS_ILPMdVoyagePlan.voyage LIKE :voyage1) OR CTS_ILPMdVoyagePlan.voyageCode LIKE :voyageCode2) AND CTS_ILPMdVoyagePlan.isDeleted = :isDeleted3)"
      }

      let data = {
        action: "query",
        crudType: "SELECT",
        mainModelName: "CTS_ILPMdVoyagePlan",
        tag: "CTS_ILP_es",
        where: whereObj,
        currentPage: currentPage,
        pageSize: pageSize,
        returnPage: true,
        returnTotal: false,
        reqArgs: params,
        fields: [
          "CTS_ILPMdVoyagePlan.mdVoyagePlanId",
          "CTS_ILPMdVoyagePlan.createTime",
          "CTS_ILPMdVoyagePlan.principalGroupCode",
          "CTS_ILPMdVoyagePlan.customsVesselName",
          "CTS_ILPMdVoyagePlan.lastModifyTime",
          "CTS_ILPMdVoyagePlan.isDeleted",
          "CTS_ILPMdVoyagePlan.remark",
          "CTS_ILPMdVoyagePlan.recordVersion",
          "CTS_ILPMdVoyagePlan.voyage",
          "CTS_ILPMdVoyagePlan.voyageCode",
          "CTS_ILPMdVoyagePlan.createOffice",
          "CTS_ILPMdVoyagePlan.customsVoyage",
          "CTS_ILPMdVoyagePlan.vesselId",
          "CTS_ILPMdVoyagePlan.appCode",
          "CTS_ILPMdVoyagePlan.createOfficeName",
          "CTS_ILPMdVoyagePlan.creatorName",
          "CTS_ILPMdVoyagePlan.creatorId",
          "CTS_ILPMdVoyagePlan.customsVesselId",
          "CTS_ILPMdVoyagePlan.lastModifyOfficeName",
          "CTS_ILPMdVoyagePlan.lastModifyOffice",
          "CTS_ILPMdVoyagePlan.lastModifierName",
          "CTS_ILPMdVoyagePlan.ioFlag",
          "CTS_ILPMdVoyagePlan.carrierId",
          "CTS_ILPMdVoyagePlan.lastModifierId",
          "CTS_ILPMdVoyagePlan.vesselName",
          "CTS_ILPMdVoyagePlan.carrierName",
        ],
        enableCascade: true,
      };

      return new Promise((resolve) => {
        queryVoyageInfo(data).then((res) => {
          console.log("queryVoyageInfo", res);
          resolve({
            records: res.data.data,
            total: res.data.totalRecord,
          });
        });
      }).catch((err) => {
        console.log(err);
      });
    },
    // 驳船航次联想控件数据源
    associate_queryMethod_voyage2({keyword, pageSize, currentPage}) {
      let params = {};
      let whereObj = null
      if (keyword === "") {
        params = {
          isDeleted3: "0",
        };
      } else {
        params = {
          isDeleted3: "0",
          vesselName0: "%" + keyword + "%",
          voyage1: "%" + keyword + "%",
          voyageCode2: "%" + keyword + "%",
        };
      }
      if (this.ebOrder.bargeVesselName) {
        params.vesselId = this.ebOrder.bargeVesselId
        whereObj = "(((CTS_ILPMdVoyagePlan.vesselName LIKE :vesselName0 OR CTS_ILPMdVoyagePlan.voyage LIKE :voyage1) OR CTS_ILPMdVoyagePlan.voyageCode LIKE :voyageCode2) AND CTS_ILPMdVoyagePlan.isDeleted = :isDeleted3 AND CTS_ILPMdVoyagePlan.vesselId = :vesselId)"
      } else {
        whereObj = "(((CTS_ILPMdVoyagePlan.vesselName LIKE :vesselName0 OR CTS_ILPMdVoyagePlan.voyage LIKE :voyage1) OR CTS_ILPMdVoyagePlan.voyageCode LIKE :voyageCode2) AND CTS_ILPMdVoyagePlan.isDeleted = :isDeleted3)"
      }

      let data = {
        action: "query",
        crudType: "SELECT",
        mainModelName: "CTS_ILPMdVoyagePlan",
        tag: "CTS_ILP_es",
        where: whereObj,
        currentPage: currentPage,
        pageSize: pageSize,
        returnPage: true,
        returnTotal: false,
        reqArgs: params,
        fields: [
          "CTS_ILPMdVoyagePlan.mdVoyagePlanId",
          "CTS_ILPMdVoyagePlan.createTime",
          "CTS_ILPMdVoyagePlan.principalGroupCode",
          "CTS_ILPMdVoyagePlan.customsVesselName",
          "CTS_ILPMdVoyagePlan.lastModifyTime",
          "CTS_ILPMdVoyagePlan.isDeleted",
          "CTS_ILPMdVoyagePlan.remark",
          "CTS_ILPMdVoyagePlan.recordVersion",
          "CTS_ILPMdVoyagePlan.voyage",
          "CTS_ILPMdVoyagePlan.voyageCode",
          "CTS_ILPMdVoyagePlan.createOffice",
          "CTS_ILPMdVoyagePlan.customsVoyage",
          "CTS_ILPMdVoyagePlan.vesselId",
          "CTS_ILPMdVoyagePlan.appCode",
          "CTS_ILPMdVoyagePlan.createOfficeName",
          "CTS_ILPMdVoyagePlan.creatorName",
          "CTS_ILPMdVoyagePlan.creatorId",
          "CTS_ILPMdVoyagePlan.customsVesselId",
          "CTS_ILPMdVoyagePlan.lastModifyOfficeName",
          "CTS_ILPMdVoyagePlan.lastModifyOffice",
          "CTS_ILPMdVoyagePlan.lastModifierName",
          "CTS_ILPMdVoyagePlan.ioFlag",
          "CTS_ILPMdVoyagePlan.carrierId",
          "CTS_ILPMdVoyagePlan.lastModifierId",
          "CTS_ILPMdVoyagePlan.vesselName",
          "CTS_ILPMdVoyagePlan.carrierName",
        ],
        enableCascade: true,
      };

      return new Promise((resolve) => {
        queryVoyageInfo(data).then((res) => {
          console.log("queryVoyageInfo", res);
          resolve({
            records: res.data.data,
            total: res.data.totalRecord,
          });
        });
      }).catch((err) => {
        console.log(err);
      });
    },
    // 作业码头联想控件数据源
    associate_queryMethod_terminal({keyword, pageSize, currentPage}) {
      let params = {};
      if (keyword === "") {
        params = {
          custType3: "%PI%",
          isDeleted6: "0",
          isBlacklist: "0",
        };
      } else {
        params = {
          custAlias0: "%" + keyword + "%",
          custNameCn1: "%" + keyword + "%",
          custType3: "%PI%",
          isDeleted6: "0",
          isBlacklist: "0",
          mdmCustCode3: "%" + keyword + "%",
          mnemonicCode2: "%" + keyword + "%",
        };
      }

      let data = {
        action: "query",
        crudType: "SELECT",
        sorting: ["CTS_ILPCsCust.custNameCn"],
        mainModelName: "CTS_ILPCsCust",
        tag: "CTS_WEB_es",
        where: "(((((CTS_ILPCsCust.custAlias LIKE :custAlias0 OR CTS_ILPCsCust.custNameCn LIKE :custNameCn1) ) AND CTS_ILPCsCust.esCustType LIKE :custType4) ) AND CTS_ILPCsCust.isDeleted = :isDeleted6)",
        currentPage: currentPage,
        pageSize: pageSize,
        returnPage: true,
        returnTotal: false,
        reqArgs: params,
        fields: [
          "CTS_ILPCsCust.csCustId",
          "CTS_ILPCsCust.custAlias",
          "CTS_ILPCsCust.custNameCn",
          "CTS_ILPCsCust.custNameEn",
          "CTS_ILPCsCust.customsRegisteredNo",
          "CTS_ILPCsCust.esCustType",
          "CTS_ILPCsCust.isActive",
          "CTS_ILPCsCust.isBlacklist",
          "CTS_ILPCsCust.isCustomer",
          "CTS_ILPCsCust.isDeleted",
          "CTS_ILPCsCust.isOneTimeCustomer",
          "CTS_ILPCsCust.isSettlement",
          "CTS_ILPCsCust.isSupplier",
          "CTS_ILPCsCust.legalPerson",
          "CTS_ILPCsCust.mdmCustCode",
          "CTS_ILPCsCust.mobileNo",
          "CTS_ILPCsCust.postCode"
        ],
        enableCascade: true
      };
      return new Promise((resolve) => {
        queryCarrierInfo(data).then((res) => {
          console.log("queryCarrierInfo", res);
          resolve({
            records: res.data.data,
            total: res.data.totalRecord,
          });
        });
      }).catch((err) => {
        console.log(err);
      });
    },
    // 拼箱checkBox改变事件
    onChangeIsLcl() {
      let self = this;
      if (self.ebOrder.isLcl === 1) {
        self.ebOrder.bizTypeCode = "MFEL";
        self.ebOrder.bizTypeName = "海运拼箱出口分单";
        self.ebOrder.bizBigTypeCode = "MFE";
        self.ebOrder.bizBigTypName = "海运集装箱出口";
      } else if (self.ebOrder.isLcl === 0) {
        self.ebOrder.bizTypeCode = "MFEF";
        self.ebOrder.bizTypeName = "海运整箱出口";
        self.ebOrder.bizBigTypeCode = "MFE";
        self.ebOrder.bizBigTypName = "海运集装整箱出口";
      }
      console.log("self.ebOrder.bizBigTypeCode:", self.ebOrder.bizBigTypeCode);
      console.log("self.ebOrder.bizBigTypName:", self.ebOrder.bizBigTypName);
    },
    // 签单地点
    changePlaceOfIssueName(value, selectedRows) {
      this.ebOrder.placeOfIssueName = selectedRows.portNameEn;
      this.ebOrder.placeOfIssueId = selectedRows.mdPortId;
    },
    // 华贸分公司
    changeCsOffice(value, selectedRows) {
      this.ebOrder.settleOfficeName = selectedRows.corpNameCn;
      this.ebOrder.settleOffice = selectedRows.sysCorpId;
    },
    //华贸客服联想控件改变事件
    onChangeCsOffice(value, selectedRows) {
      console.log("selectedRows", selectedRows);
      this.ebOrder.csName = selectedRows.userNameCn;
      this.ebOrder.csId = selectedRows.sysUserId;
      this.ebOrder.csEmail = selectedRows.email
      this.ebOrder.csTel = selectedRows.tel
      this.ebOrder.mobile = selectedRows.mobilePhone
    },
    //大船船名联想控件修改事件
    onChangeVessel(value, selectedRows) {
      console.log("selectedRows", selectedRows);
      this.ebOrder.vesselId = selectedRows.vesselId;
      this.ebOrder.vesselNameEn = selectedRows.vesselName
      this.ebOrder.voyage = selectedRows.voyage;
    },
    // 大船航次联想控件修改事件
    onChangeVoyage(value, selectedRows) {
      console.log("selectedRows", selectedRows);
      this.ebOrder.voyage = selectedRows.voyage;
    },
    /*//实装船名联想控件修改事件
      onChangeRealVessel(value, selectedRows) {
        console.log("selectedRows", selectedRows)
        this.ebOrder.realVesselId = selectedRows.mdVesselId
      },*/
    //驳船船名联想控件修改事件
    onChangeBargeVessel(value, selectedRows) {
      console.log("selectedRows", selectedRows);
      this.ebOrder.bargeVesselId = selectedRows.vesselId;
      this.ebOrder.bargeVesselName = selectedRows.vesselName
      this.ebOrder.bargeVoyage = selectedRows.voyage;
    },
    //作业码头联想控件修改事件
    onChangeTerminal(value, selectedRows) {
      console.log("selectedRows", selectedRows);
      this.ebOrder.terminalId = selectedRows.csCustId;
      this.ebOrder.terminalName = selectedRows.custAlias;
    },
    // 付款地点
    changeMblPaymentPlace(value, selectedRows) {
      this.ebOrder.mblPaymentPlace = selectedRows.portNameEn;
      this.ebOrder.mblPaymentPlaceId = selectedRows.mdPortId;
    },
    //驳船作业码头联想控件修改事件
    onChangeBargeTerminal(value, selectedRows) {
      console.log("selectedRows", selectedRows);
      this.ebOrder.bargeTerminalId = selectedRows.csCustId;
    },
    //收货地联想控件修改事件
    onChangePor(value, selectedRows) {
      console.log("selectedRows", selectedRows);
      this.ebOrder.porId = selectedRows.mdPortId;
      this.ebOrder.porCode = selectedRows.portCode;
    },
    //装货港联想控件修改事件
    onChangePol(value, selectedRows) {
      console.log("selectedRows", selectedRows);
      this.ebOrder.polId = selectedRows.mdPortId;
      this.ebOrder.polCode = selectedRows.portCode;
    },
    //中转港联想控件修改事件
    onChangePot(value, selectedRows) {
      console.log("selectedRows", selectedRows);
      this.ebOrder.potId = selectedRows.mdPortId;
      this.ebOrder.potCode = selectedRows.portCode;
    },
    //卸货港联想控件修改事件
    onChangePod(value, selectedRows) {
      console.log("selectedRows", selectedRows);
      this.ebOrder.podId = selectedRows.mdPortId;
      this.ebOrder.podCode = selectedRows.portCode;
    },
    //交货地联想控件修改事件
    onChangePlaceOfDelivery(value, selectedRows) {
      console.log("selectedRows", selectedRows);
      this.ebOrder.placeOfDeliveryId = selectedRows.mdPortId;
      this.ebOrder.placeOfDeliveryCode = selectedRows.portCode;
    },
    //箱公司联想控件修改事件
    onChangeCtnCompany(value, selectedRows) {
      console.log("selectedRows", selectedRows);
      // this.ebOrder.ctnCompanyId = selectedRows.csCustId;
      this.ebCtnRequests[this._index].ctnCompanyId = selectedRows.csCustId;
    },
    //服务项修改事件
    onChangeEbServiceItem(val) {
      console.log(val)
      console.log("ebServiceItemList", this.ebServiceItemList);
    },
    // 修改表格后事件
    afterChangeEbCtnRequest(change, source) {
      console.log("change", change);
      let self = this;
      if (change != null) {
        // change[0][0] 第几条数据 from 0  source[ change[0][0] ]
        // change[0][1] 字段名 eg：ediCodeName
        // change[0][2] 原值
        // change[0][3] 新值
        if (self.ebCtnRequests.length !== 0) {
          if (
            change[0][1] !== "$$checked" &&
            change[0][2] !== change[0][3] &&
            self.ebCtnRequests[change[0][0]].rowStatus !== 4
          ) {
            self.ebCtnRequests[change[0][0]].rowStatus = 16;
            console.log("修改行", this.ebCtnRequests[change[0][0]]);
          }
        }
      }
      // 汇总箱型箱量信息
      this.ebOrder.ctnNum = ''
      let ctnNumArr = []
      if (this.ebCtnRequests.length > 0) {
        this.ebCtnRequests.forEach((el, i) => {
          if (el.ctnQuantity && el.ctnSizeType) {
            ctnNumArr.push(el.ctnSizeType + '*' + el.ctnQuantity)
          }
        })
      }
      ctnNumArr.forEach(el => {
        this.ebOrder.ctnNum = this.ebOrder.ctnNum + '+' + el
      })
      this.ebOrder.ctnNum = this.ebOrder.ctnNum.slice(1);
      this.$route.meta.verifyValue = false;
      this.$store.dispatch("tagsView/updateVisitedView", this.$route);
    },
    // 修改表格后事件
    afterChangeEbCtnRequestDetail(change, source) {
      console.log("change", change);
      let self = this;
      if (change != null) {
        // change[0][0] 第几条数据 from 0  source[ change[0][0] ]
        // change[0][1] 字段名 eg：ediCodeName
        // change[0][2] 原值
        // change[0][3] 新值
        if (
          change[0][1] !== "$$checked" &&
          change[0][2] !== change[0][3] &&
          this.ebCtnRequestDetails[change[0][0]].rowStatus !== 4
        ) {
          self.ebCtnRequestDetails[change[0][0]].rowStatus = 16;
          console.log("修改行", this.ebCtnRequestDetails[change[0][0]]);
        }
      }
      this.$route.meta.verifyValue = false;
      this.$store.dispatch("tagsView/updateVisitedView", this.$route);
    },
    // 新增行
    addNewRow() {
      let self = this;
      let newRow = [
        {
          rowStatus: 4, // 新增行状态值为4，修改行状态值为16
          isDeleted: 0,
          fclLclFlag: "FCL",
          isNor: 0,
          isSoc: 0,
        },
      ];
      self.ebCtnRequests = newRow.concat(self.ebCtnRequests);
      // 选中第一条高亮显示
      self.$refs.ebCtnRequestRef.hotInstance.addHookOnce(
        "afterLoadData",
        function () {
          self.$nextTick(function () {
            self.$refs.ebCtnRequestRef.hotInstance.selectCell(0, 1);
          });
        }
      );
    },
    //数据格式转换
    bookingVOToDTO() {

    },
    //暂存草稿
    compare(property) {
      return function (a, b) {
        var value1 = Number(a[property].substring(a[property].length - 16));
        var value2 = Number(b[property].substring(b[property].length - 16));
        return value1 - value2;
      }
    },

    saveNew() {
      let self = this;
      // self.saveNewVisible = true
      // self.ebOrder.rowStatus = 4
      //ebParty表单校验
      let ebPartyValid = self.$refs.ebPartyRef.ebPartyValidate();
      //ebCargo表单校验
      let ebCargoValid = self.$refs.ebCargoRef.ebCargoValidate();
      //ebOrder校验
      self.$refs.bookingFormRef.validate(ebOrderValid => {
        //ebCtnRequest表格校验
        self.$refs.ebCtnRequestRef.hotInstance.validateColumns([1, 2], ebCtnRequestValid => {
          if (ebPartyValid && ebCargoValid && ebOrderValid && ebCtnRequestValid) {

            self.ebOrder.ebPartys = [];
            for (let key in self.ebParams.ebPartys) {
              self.ebOrder.ebPartys.push(self.ebParams.ebPartys[key]);
            }

            self.ebOrder.ebCtnRequests = self.ebCtnRequests;
            if (self.ebCtnRequestDetails && self.ebCtnRequestDetails.length > 0 && self.ebCtnRequestDetailDelete.length > 0) {
              self.ebOrder.ebCtns = self.ebCtnRequestDetails.concat(self.ebCtnRequestDetailDelete);
            }
            self.ebOrder.ebCargos = [self.ebParams.ebCargos.ebCargoM];
            self.ebOrder.ebCargoDetails = self.ebParams.ebCargos.ebCargoD;
            self.ebOrder.type = "SAVE";

            // if (self.ebOrder.orderStatus === 'NEW' || self.ebOrder.orderStatus === 'REF') {
            let bookingDTO = self.bookingVOToDTO();
            // 拷贝一份数据回来的服务项
            let ebServiceItemsCopy = []
            let ebServiceItemListLike = []
            if (self.ebOrder.ebServiceItems && self.ebOrder.ebServiceItems.length > 0) {
              // self.ebOrder.ebServiceItems = self.ebOrder.ebServiceItems.sort(self.compare('ebServiceItemId'))
              ebServiceItemsCopy = JSON.parse(JSON.stringify(self.ebOrder.ebServiceItems))
              ebServiceItemsCopy.forEach(el => {
                ebServiceItemListLike.push(el.serviceCode + "/" + el.serviceName)
              })
            }
            // let ebServiceItemListCopy = JSON.parse(JSON.stringify(self.ebServiceItemList))
            ebServiceItemListLike = [...new Set(ebServiceItemListLike.concat(self.ebServiceItemList))]
            let ebServiceItemListCopy = JSON.parse(JSON.stringify(self.ebServiceItemList))
            self.ebOrder.ebServiceItems = []
            ebServiceItemListCopy.forEach((el, index) => {
              ebServiceItemsCopy.forEach((v, flag) => {
                if (v !== "0" && el.split('/')[0] === v.serviceCode) {
                  self.ebOrder.ebServiceItems.push(v)
                  // ebServiceItemListCopy.splice(index,1)
                  ebServiceItemsCopy[flag] = "0"
                  ebServiceItemListLike[flag] = "0"
                }
              })
            })
            ebServiceItemsCopy.forEach((el, index) => {
              if (el !== "0") {
                if (el.rowStatus && el.rowStatus === 2) {
                  el.rowStatus = 8
                  self.ebOrder.ebServiceItems.push(el)
                }
              }
            })
            // 判断是否为新增
            if (self.ebServiceItemsBuffer && self.ebServiceItemsBuffer.length > 0) {
              if (ebServiceItemListLike.length > self.ebServiceItemsBuffer.length) {
                for (let i = ebServiceItemListLike.length - 1; i < ebServiceItemListLike.length; i++) {
                  self.ebOrder.ebServiceItems.push({
                    serviceName: ebServiceItemListLike[i].split('/')[1],
                    serviceCode: ebServiceItemListLike[i].split('/')[0],
                    rowStatus: 4
                  })
                }
              } else {
                if (self.ebServiceItemList.length === ebServiceItemListLike.length) {
                  self.ebOrder.ebServiceItems.forEach(el => {
                    if (el.rowStatus === 8) {
                      el.rowStatus = 2
                    }
                  })
                }
              }
            } else {
              if (ebServiceItemListLike.length > 0) {
                ebServiceItemListLike.forEach(el => {
                  self.ebOrder.ebServiceItems.push({
                    serviceName: el.split('/')[1],
                    serviceCode: el.split('/')[0],
                    rowStatus: 4
                  })
                })
              }
            }
            saveAndSub({ebOrderDTO: self.ebOrder, dataType: "ORDER"}).then((res) => {
              if (res.success) {
                self.ebCargo.ebCargoD = []
                self.ebOrder = res.records;
                self.ebOrder.noOfOriginal = self.ebOrder.noOfOriginal.toString()
                self.ebOrder.noOfCopy = self.ebOrder.noOfCopy.toString()
                self.ebCtnRequests = self.ebOrder.ebCtnRequests;
                self.ebCtnRequestDetails = res.records.ebCtns;
                let checkedArr = []
                if (self.ebOrder.ebServiceItems && self.ebOrder.ebServiceItems.length > 0) {
                  self.ebOrder.ebServiceItems.forEach((el, index) => {
                    checkedArr.push(el.serviceCode + '/' + el.serviceName)
                  })
                }
                self.ebPartys = {}
                if (res.records.ebPartys.length > 0) {
                  res.records.ebPartys.forEach(el => {
                    self.ebPartys['ebParty' + el.partyType] = el
                  })
                }
                // self.ebParty = self.ebPartys
                self.ebParams.ebPartys = self.ebPartys
                if (res.records.ebCargos.length > 1) {
                  res.records.ebCargos.forEach(el => {
                    if (el.totalFlag === 'M') {
                      self.ebCargo.ebCargoM = el
                    } else {
                      self.ebCargo.ebCargoD.push(el);
                    }
                  })
                }
                self.ebServiceItemList = checkedArr
                self.ebServiceItemsBuffer = res.records.ebServiceItems;
                self.$coreMethods.message("success", this.$t('message.saveSuccessful'));
              } else {
                self.$coreMethods.message("error", this.$t('message.saveFailed'));
              }
            });
          }
        })
      });
    },
    //提交
    submit() {
      let self = this;
      self.ebOrder.urgentLevel = "N";
      let userInfo = JSON.parse(localStorage.getItem('userInfo'))
      self.ebOrder.submitPersonId = userInfo.userId;
      self.ebOrder.submitPerson = userInfo.userNameCn;
      self.ebOrder.ebPartys = [];
      for (let key in self.ebParams.ebPartys) {
        self.ebOrder.ebPartys.push(self.ebParams.ebPartys[key]);
      }
      self.ebOrder.ebCtnRequests = self.ebCtnRequests;
      if (self.ebCtnRequestDetails && self.ebCtnRequestDetails.length > 0 && self.ebCtnRequestDetailDelete.length > 0) {
        self.ebOrder.ebCtns = self.ebCtnRequestDetails.concat(self.ebCtnRequestDetailDelete);
      }
      self.ebOrder.ebCargos = [self.ebParams.ebCargos.ebCargoM];
      self.ebOrder.ebCargoDetails = self.ebParams.ebCargos.ebCargoD;
      self.ebOrder.rowStatus = 4;
      //ebParty表单校验
      let ebPartyValid = self.$refs.ebPartyRef.ebPartyValidate();
      //ebCargo表单校验
      let ebCargoValid = self.$refs.ebCargoRef.ebCargoValidate();
      //ebOrder校验
      self.$refs.bookingFormRef.validate(async ebOrderValid => {
        //ebCtnRequest表格校验
        self.$refs.ebCtnRequestRef.hotInstance.validateColumns([1, 2], ebCtnRequestValid => {
          if (ebPartyValid && ebCargoValid && ebOrderValid && ebCtnRequestValid) {
            // if (self.ebOrder.orderStatus === 'NEW' || self.ebOrder.orderStatus === 'REF') {
            self.ebOrder.ebServiceItems = []
            self.ebServiceItemList.forEach(el => {
              self.ebOrder.ebServiceItems.push({
                serviceName: el.split('/')[1],
                serviceCode: el.split('/')[0],
                rowStatus: 4
              })
            })
            let saveServiceItem = []
            let copyEbServiceItems = [];
            let copyEbServiceItemsBuffer = [];
            if (self.ebOrder.ebServiceItems.length > 0) {
              copyEbServiceItems = JSON.parse(JSON.stringify(self.ebOrder.ebServiceItems))
            }
            if (self.ebOrder.ebServiceItemsBuffer && self.ebOrder.ebServiceItemsBuffer.length > 0) {
              copyEbServiceItemsBuffer = JSON.parse(JSON.stringify(self.ebServiceItemsBuffer))
            }
            self.ebOrder.ebServiceItems.forEach((el, i) => {
              self.ebServiceItemsBuffer.forEach((v, flag) => {
                if (el.serviceCode === v.serviceCode) {
                  saveServiceItem.push(v)
                  if (copyEbServiceItemsBuffer.length < self.ebServiceItemsBuffer.length) {
                    copyEbServiceItemsBuffer.splice(flag - 1, 1)
                    copyEbServiceItems.splice(i - 1, 1)
                  } else {
                    copyEbServiceItemsBuffer.splice(flag, 1)
                    copyEbServiceItems.splice(i, 1)
                  }
                }
              })
            })
            if (copyEbServiceItemsBuffer.length > 0) {
              copyEbServiceItemsBuffer.forEach((v, flag) => {
                v.rowStatus = 8
                saveServiceItem.push(v)
              })
            }
            if (copyEbServiceItems.length > 0) {
              copyEbServiceItems.forEach((v, flag) => {
                saveServiceItem.push(v)
              })
            }
            self.ebOrder.ebServiceItems = saveServiceItem
            self.ebCargo.ebCargoD = []
            if (self.ebOrder.orderStatus === 'UPDSUB') {
              self.ebOrder.orderStatus = 'UPDSUB'
            } else {
              self.ebOrder.type = "SUB";
            }
            if (self.ebOrder.ebOrderId) {
              saveAndSub({ebOrderDTO: self.ebOrder, dataType: "ORDER"}).then((res) => {
                if (res.success) {
                  self.submitVisible = true;
                  self.$coreMethods.message("success", this.$t('message.submittedSuccessfully'));
                  //关闭并跳转
                  self.$store.dispatch("tagsView/delView", self.$route).then(() => {
                    self.$nextTick(() => {
                      self.$router.push({name: 'bookingManage'})
                    });
                  });
                } else {
                  self.submitVisible = false;
                  self.$coreMethods.message("error", this.$t('message.submissionFailure'));
                }
              });
            } else {
              self.ebOrder.type = "SAS";
              saveAndSub({ebOrderDTO: self.ebOrder, dataType: "ORDER"}).then((res) => {
                if (res.success) {
                  self.ebOrder = res.records;
                  self.$coreMethods.message("success", this.$t('message.submittedSuccessfully'));
                  self.$store.dispatch("tagsView/delView", self.$route).then(() => {
                    self.$nextTick(() => {
                      self.$router.push({name: 'bookingManage'})
                    });
                  });
                } else {
                  self.submitVisible = false;
                  self.$coreMethods.message("error", this.$t('message.submissionFailure'));
                }
              });
            }
          }
        })
      });
    },
    // 场内场外求和
    sumFreeDaysChange() {
      if (this.ebOrder.freeStorage && this.ebOrder.freeOfDetention) {
        this.ebOrder.freeDays = parseInt(this.ebOrder.freeStorage) + parseInt(this.ebOrder.freeOfDetention)
        this.$forceUpdate()
      }
    },
    //取消提交
    //增加【撤销提交】按钮，点击按钮，更新EI_ORDER表的IS_ACTIVE = 0
    cancelSubmit() {
      let self = this;
      self.$coreMethods.confirm(function () {
        let orderStatus = ""
        if (self.ebOrder.orderStatus === 'SUB') {
          orderStatus = "NEW"
        } else if (self.ebOrder.orderStatus === 'UPDSUB') {
          orderStatus = "CRM"
        }
        revokeSub({"ebOrderId": self.ebOrder.ebOrderId, "orderStatus": orderStatus}).then((res) => {
          if (res.success) {
            self.ebOrder.orderStatus = orderStatus;
            self.$coreMethods.message("success", this.$t('message.undoSubmissionSuccessful'));
            self.submitVisible = true;
          } else {
            self.$coreMethods.message("error", this.$t('message.failedToUndoCommit'));
          }
        });
      }, function () {
      }, false, this.$t('message.whetherToCancel'))
    },
    //存为模板
    saveTemplate: async function () {
      let self = this;
      //ebParty表单校验
      let ebPartyValid = await self.$refs.ebPartyRef.ebPartyValidate();
      //ebCargo表单校验
      let ebCargoValid = await self.$refs.ebCargoRef.ebCargoValidate();
      //ebOrder校验
      self.$refs.bookingFormRef.validate(async (ebOrderValid) => {
        //ebCtnRequest表格校验
        self.$refs.ebCtnRequestRef.hotInstance.validateColumns(
          [1, 2],
          (ebCtnRequestValid) => {
            //if (ebPartyValid && ebCargoValid && ebOrderValid && ebCtnRequestValid) {
            let bookingDTO = self.bookingVOToDTO();
            saveBookingDTO(bookingDTO).then((res) => {
              /**待办：需要把保存后的数据回显到界面或是把ebOrderId传递出来 **/
              if (res.success) {
                //获取保存成功之后的数据
                self.getBookingDataByEbOrderIdAndFlag(res.data, 1);
                let ebCargos = [];
                self.ebCargo.ebCargoD.forEach((item) => {
                  ebCargos.push(item);
                });
                ebCargos.push(self.ebCargo.ebCargoM);
                let ebParties = [];
                for (let key in self.ebParty) {
                  ebParties.push(self.ebParty[key]);
                }
                self.allBookingDTO = {
                  ebOrder: self.ebOrder,
                  ebCtnRequests: self.ebCtnRequests,
                  ebCtnRequestDetails: self.ebCtnRequestDetails,
                  ebServiceItems: self.ebServiceItems,
                  ebParties: ebParties,
                  ebCargos: ebCargos,
                };
                self.saveTemplateVisible = !self.saveTemplateVisible;
              } else {
                self.$coreMethods.message("error", this.$t('message.saveFailed'));
              }
            });
            // }
          }
        );
      });
    },
    //改配历史
    changeHistory() {
      this.changeHistoryVisible = !this.changeHistoryVisible;
    },
    //批量删除预配箱信息
    batchDeleteEbCtnRequest() {
      let self = this;
      let delFlag = true;
      let deleteParams = [];
      let params = self.$refs.ebCtnRequestRef.getSelections();
      // 判断是否选中行都为新增行
      params.forEach(item => {
        if (item.rowStatus !== 4) {
          deleteParams.push(item);
          delFlag = false;
        }
      })
      // 如果删除行都为新增行则不进行数据库操作
      if (params.length !== 0) {
        self.$coreMethods.confirm(function () {
          if (delFlag) {
            // 删除操作
            params.forEach((item) => {
              let index = self.ebCtnRequests.indexOf(item);
              self.ebCtnRequests.splice(index, 1);
              item.rowStatus = 8;
            });
            self.synchronizeToDetail(true)
          } else {
            let ebCtnRequestIds = []
            deleteParams.forEach(el => {
              ebCtnRequestIds.push(el.ebCtnRequestId)
            })
            deleteEbCtnRequest({"ebCtnRequestIds": ebCtnRequestIds}).then(res => {
              if (res.success) {
                params.forEach((item) => {
                  let index = self.ebCtnRequests.indexOf(item);
                  self.ebCtnRequests.splice(index, 1);
                  self.$coreMethods.message('success', this.$t('message.deleteFailed'));
                });
                self.synchronizeToDetail(true)
              }
            })
          }
        }, function () {
        }, false, this.$t('message.whetherToDelete'))
      } else {
        self.$coreMethods.message('warning', this.$t('message.checkDataDeleted'));
      }
    },
    //同步至明细
    synchronizeToDetail(flag) {
      let self = this;
      let ebCtnRequestDetailData = [];
      if (self.ebCtnRequestDetails && self.ebCtnRequestDetails.length > 0) {
        self.ebCtnRequestDetails.forEach((item) => {
          item.rowStatus = 8;
        });
      }
      self.ebCtnRequestDetailDelete = self.ebCtnRequestDetails;

      self.ebCtnRequests.forEach((item) => {
        for (let i = 0; i < item.ctnQuantity; i++) {
          let ebCtnRequestDetail = {
            ebOrderId: self.ebOrder.ebOrderId,
            ctnSizeType: item.ctnSizeType,
            ctnQuantity: 1,
            ctnCompanyName: item.ctnCompanyName,
            ctnCompanyId: item.ctnCompanyId,
            isSoc: item.isSoc,
            isNor: item.isNor,
            fclLclFlag: item.fclLclFlag,
            rowStatus: 4,
          };
          ebCtnRequestDetailData.push(ebCtnRequestDetail);
        }
      });
      self.ebCtnRequestDetails = ebCtnRequestDetailData;
      self.boxVisible = flag;
      let containerWidth =
        document.getElementById("boxDiv").clientWidth - 21.22;
      this.$nextTick(() => {
        this.$refs.ebCtnRequestDetailRef.resizeTo(containerWidth);
      });
    },
    // 获取收发通组件中的数据
    getEbPartyInfoEn(value) {
      console.log("收发通组件数据：", value);
      this.ebParams.ebPartys = value;
    },
    /*// 获取收发通组件中的数据
    getEbPartyInfo(value) {
      console.log("收发通组件数据：", value);
      this.ebParams.ebPartys = value;
    },*/
    // 获取货物信息组件中的数据
    getEbCargoInfo(value) {
      console.log("货物信息组件数据：", value);
      this.ebParams.ebCargos = value;
    },
    //预配箱信息单元格点击事件
    ebCtnRequestCellClick(row) {
      this._index = row.row
    },
    //预配箱信息单击行事件
    ebCtnRequestRowClick() {
    },
    //预配箱详情单元格点击事件
    ebCtnRequestDetailCellClick() {
    },
    //预配箱详情单击行事件
    ebCtnRequestDetailRowClick() {
    },
    boxInfoFn() {
      this.boxVisible = true;
      let containerWidth =
        document.getElementById("boxDiv").clientWidth - 21.22;
      this.$nextTick(() => {
        this.$refs.ebCtnRequestRef.resizeTo(containerWidth);
      });
    },
    boxDetailFn() {
      this.boxVisible = false;
      let containerWidth =
        document.getElementById("boxDiv").clientWidth - 21.22;
      this.$nextTick(() => {
        this.$refs.ebCtnRequestDetailRef.resizeTo(containerWidth);
      });
    },
    // 船公司扩展信息
    onChangeCarrier(value, selectedRows) {
      let self = this
      self.ebOrder.carrierId = selectedRows.csCustId
      self.carrierExpand = []
      let dicParams = []
      let params = {
        carrierId: selectedRows.csCustId,
        // carrierId: '6800302672858275840',
        type: 'BK'
      }
      if (selectedRows.csCustId) {
        getCarrierInfoStr(params).then((res) => {
          res.forEach(el => {
            self.carrierExpand.push(el)
            if (el.controlType === '01') {
              dicParams.push(el.controlBindCode)
            }
          })
          self.getCarrierSelectList(dicParams.toString());
          self.$forceUpdate()
        })
      }
    },
    //获取数据字典
    getCarrierSelectList(params) {
      queryDictRows(params).then(res => {
        this.carrierSelectList = res
      })
    },
  },
  // beforeDestroy() {
  //   let _this = this;
  //   // 离开页面删除检测器和所有侦听器
  //   _this.resizeObserver.disconnect();
  // },
  destroyed() {
    sessionStorage.removeItem('ebOrderParams')
    sessionStorage.removeItem('ebOrderType')
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      // 通过 `vm` 访问组件实例
      let _this = vm
      // _this.$store.state.tagsView.cachedViews[_this.$store.state.tagsView.cachedViews.length - 1] !== 'bookingAdd'
      if (_this.$route.params.type === 'add' && _this.bookingCount > 0) {
        _this.bookingCount++
        _this.$coreMethods.confirm(function () {

          }, function () {
            //订单
            _this.ebOrder = {
              mblTransportTermFrom: "CY",
              mblTransportTermTo: "CY",
              issueMode: "", //正本提单
              noOfOriginal: "3", //THREE(3)
              noOfCopy: "0", //ZERO(0)
              custContact: "",
              custContactTel: "",
              custContactEmail: "",
              orderStatus: "NEW",
              bizTypeCode: "MFEF",
              bizTypeName: "海运整箱出口",
              bizBigTypeCode: "MFE",
              bizBigTypeName: "海运集装整箱出口",
              inputMethond: "M",
              orderType: "F",
              isCancelApply: 0,
              // custId: "1",//登录人的委托单位
              // custName: "",//登录人的委托单位
              isLcl: 0,
              // carrierId: "1", //根据对话框中选择的船公司赋值?
              carrierName: "", //根据对话框中选择的船公司赋值?
              isDeleted: 0,
              vgmStatus: "UNSENT",
              vgmApprovalStatus: "NEW",
              transferStatus: 0,
              rowStatus: 4,
              ctnNum: ''
            };
            //货物信息
            _this.ebCargo = {
              ebCargoD: [],
              ebCargoM: {
                totalFlag: "M",
                isHazard: 0,
                isReefer: 0,
                isBulkyCargo: 0,
                isDeclare: 0,
                isOceanPollution: 0,
                rowStatus: 4,
              },
              //删除的ebCargo
              ebCargoDelete: [],
            };
            //预配箱
            _this.ebCtnRequests = [];
            //预配箱明细
            _this.ebCtnRequestDetails = [];
            //服务项
            _this.ebServiceItems = [];
            //收发通信息
            _this.ebParty = {
              //发货人
              ebPartySH: {partyType: "SH", rowStatus: 4, partyDescription: ""},
              //收获人
              ebPartyCN: {partyType: "CN", rowStatus: 4, partyDescription: ""},
              //通知人
              ebPartyNT: {partyType: "NT", rowStatus: 4, partyDescription: ""},
              //第二通知人
              ebPartyNT2: {partyType: "NT2", rowStatus: 4},
              //真实发货人
              ebPartyRSH: {partyType: "RSH", rowStatus: 4},
              //真实收获人
              ebPartyRCN: {partyType: "RCN", rowStatus: 4},
              //真实通知人
              ebPartyRNT: {partyType: "RNT", rowStatus: 4},
            }
          },
          false,
          '当前页面有修改，是否先保存？'
        )
      } else {
        _this.bookingCount++
      }
    })
  }
};
</script>

<style scoped lang="scss">
.el-scrollbar ::v-deep .el-scrollbar__wrap {
  height: 125px;

  .el-scrollbar__view {
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;

    .node-content {
      position: relative;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      width: 118px;

      .node-content-img {
        width: 50px;
        background-size: 100% 100%;
      }

      .solid-style {
        height: 1px;
        border-top: 2px solid #E58660;
        width: 69px;
        position: absolute;
        top: 24px;
        left: 83px;
      }

      .dashed-style {
        height: 1px;
        border-top: 2px solid #d7d7d7;
        width: 69px;
        position: absolute;
        top: 24px;
        left: 83px;
      }

      .node-content-name {
        margin-top: 4px;
      }

      .node-content-date {
        font-size: 12px;
        margin-top: 4px;
        width: 80px;
        text-align: center;
        white-space: pre-wrap;
      }
    }

  }
}

.status-container {
  .status-title {
    height: 30px;
    line-height: 30px;
    text-align: center;
    background-color: #ECF4FF;
    border-right: 1px solid #ffffff;
  }

  .status-content-list {
    padding: 6px 0px;

    .status-content-item {
      text-align: center;
    }
  }

  ::v-deep .el-collapse {
    margin-top: 5px;

    .el-collapse-item {
      width: 100%;

      .el-collapse-item__content {
        padding-bottom: 0px;
        background-color: #f2f2f2;
      }

      .el-collapse-item__header {
        font-size: 14px;
        color: #2f5597;
        background-color: #F2F2F2;
        height: 30px;

        .header-icon {
          margin: 3px 0px 0px 3px;
        }
      }
    }
  }
}

.position-parent {
  position: relative;
}

.position-title {
  position: absolute;
  top: -7px;
  background: #ffffff;
  padding: 0 4px;
}
.tab {
  margin-left:20px;
  width: 190px;
  display: flex;
  box-sizing: border-box;
  height: 35px;
  background-color: #fff;
  align-items: center;
  border: 1px solid #cad1e1;
  border-radius: 5px;
  .tab-item {
    width: auto;
    height: 100%;
    display: flex;
    align-items: center;
    overflow: hidden;
    white-space: nowrap;
    padding: 5px 10px;
    color: #595959;
  }
  .tab-active {
    background-color: #eaeff9;
  }
}
  .icon-none-info {
    width: 120px;
    height: 90px;
    margin: 25px auto;
  }
</style>
